import React from "react";
import {
  Container,
  Row,
  Col,
  Tab,
  Tabs,
  Alert,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { connect } from "react-redux";
import action from "../../../Actions";
import Common, { commonData } from "../../../Common";
import Header from "../../../Header";
import ReadOnlyField from "../../InlineEdit/ReadOnlyField";
import Back from "../../UI/Back";
import Message from "../../../components/UI/Message";
import ToolBar from "../../editor/ToolBar";
import Note from "../../note_details/Note";
import StatusDropDown from "../../UI/StatusDropDown";

import ErHistory from "../ErHistory";
import moment from "moment";
import { Link, withRouter } from "react-router-dom";
import AddMonitorModal from "../../UI/AddMonitorModal";
import ModalUi from "../../UI/modal/ModalUi";
import Modal from "../../UI/modal/Modal";
import { getVisibleDependencies } from "../../UI/Dependencies";
import DependenciesModal from "../../UI/DependenciesModal";
import { Button, Loading } from "../../UI";
import updateAttachmentData from "../../../Actions/updateAttachmentData";
import { clearAllAttachment } from "../../../Actions/clearAllAttachment";
import ChildBoard from "../../er/ChildBoard";
import Error from "../../Error";
import ImagePreview from "../../UI/ImagePreview";
import * as getdatacommon from "../../../Common";
import Frame from "../../../assets/images/frame.png";
import NewCustomFilter from "../../CustomFilter/CustomFilter";
import ReactSelect from "react-select";
import AsyncReactSelect from "react-select/async";
import CtaComponent from "../../CtaComponent";
import ReactDatePicker from "react-datepicker";
import axios from "axios";
import EditNote from "../../UI/modal/EditNote";
import DateTimeDisplay from "../../../utils/TimeZoneDisplay";
import ReasonNote from "../../note_details/ReasonNote";
import CopyLinkItem from "../../CopyLinkItem";
import LongTextEdit from "../../editor/LongTextEdit";
import CountDownTimer from "../../CountDownTimer";
import apiHandler from "../../../utils/apiHandler";
import ProgressReport from "../../Report/ProgressReport";
import NotesAttatchment from "../../UI/NotesAttatchment";
import GmailReplyCollapse from "../../UI/GmailReplyCollapse";

class View extends Common {
  constructor(props) {
    super(props);
    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      reasonModal: false,
      has_dependencies: false,
      dependencies: {},
      dependencySelectStatus: {},
      isStatusDependency: false,
      pendingDependencyEdit: null,
      dependencyModalTitle: "Update required for the below fields",
      loginData: {},
      titleDetails: "",
      attributes: {},
      people: [],
      long_text: [],
      uploaderData: [],
      buttonDisabled: false,
      isAddReason: false,
      isAddingButton: false,
      newMonitor: [],
      attachment_pane: [],
      isLongText: {},
      isStatusChanging: false,
      buttonDisabledStatus: false,
      history_attributes: [],
      imageFailed: [],
      isStatusChanged: false,
      validDescription: "",
      validDescriptionLongText: "",
      monitor: [],
      activeTabKey: "note",
      isAddingNote: false,
      pauseSelectStatus: {},
      long_text_edit: {},
      isLinkify: false,
      reasonNote: "",
      apiDataResponse: [],
      isCallingBoard: false,
      mainImageUpload: false,
      currentSelectedStatusName: "",
      details: [],
      users: {},
      reason_pane_type: "",
      hidden_panel: [],
      release_pane: [],
      scrollSpec: false,
      removeAttachmentId: "",
      isDelete: false,
      isNoteCopyUrl: false,
      status: [],
      child_boards: [],
      populateFormError: {},
      reasonFilteredField: [],
      updateContent: "",
      singleEditByReason: {},
      json_content: "",
      users: [],
      removeIdMonitoring: "",
      notes: [],
      recentVisited: [],
      validTitle: true,
      attachments: [],
      reasonaskingdata: { note: "" },
      show_more_attribute: false,
      title: [],
      history: [],
      copyActive: false,
      attachShow: false,
      user: [],
      copyActive: false,
      removeIdMonitoring: "",
      isUpdate: false,
      mentions: [],
      description: [],
      scrollToView: false,
      boardDetails: {},
      planning_date: [],
      dev_planning_date: [],
      editNote: {},
      progressInfos: [],
      isChangingCategory: false,
      selectStatus: {
        color: "",
        name: "",
      },
      convertNotes: [],
      editImages: [],
      boardName: {},
      modalError: "",
      showInline: false,
      loading: false,
      rows: [],
      boarddetails: {
        attribute_set_key: this.getBoardDetails().attribute_set_key,
        attribute_set_name: this.getBoardDetails().attribute_set_name,
      },
      createBoard: {
        board: false,
        title: "",
        message: "",
        position: "bottom-end",
        bg: "",
      },
      dropdown: false,
      descEdit: false,
      currentTitleValue: "",
      showMonitor: false,
      noteType: {
        is_internal: true,
        is_customer: false,
      },
      editModal: false,
      boarddata: {},
      isMultiple: "",
      board_attributes: [],
      childBoardDataChanged: false,
      childLoading: true,
      filterData: [],
      clearSegment: null,
    };
    this.inlineEdit = React.createRef(null);
    this.dropref = React.createRef();
    this.titleEditFocus = React.createRef();
    this.modalUiRef = React.createRef(null);
    this.toolbarRef = React.createRef(null);
    this.toolbarRefNote = React.createRef(null);
    this.arrayNew = [];
    this.createFormData = {};
    this.apperror = React.createRef({ isValid: true, message: "" });
  }

  progressFilterChanged = (fil) => {
    this.setState((prevState) => ({
      ...prevState,
      filterData: fil,
    }));
  };

  setClearSegment = (fun) => {
    this.setState({ clearSegment: fun });
  };

  childBoardDataChanged = () => {
    this.setState((prevState) => ({
      ...prevState,
      childBoardDataChanged: !prevState.childBoardDataChanged,
    }));
  };
  childLoading = (val) => {
    this.setState((prevState) => ({
      ...prevState,
      childLoading: val,
    }));
  };
  scrollToTarget = () => {
    const { hash } = window.location;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "auto" });
        this.setState({ scrollToView: false });
      }
    } else {
      if (hash) {
        setInterval(() => {
          this.scrollToTarget();
        }, 0);
      } else {
        window.scrollTo(0, 0); // Scroll to top if no hash in the URL
        this.setState({ scrollToView: false });
      }
    }
  };

  removeItemHandler = async (id, attribute_key) => {
    try {
      let inputs = {
        app_token: this.state.boarddata.app_token,
        attribute_set_key: this.props.match.params.attribute_set_key,
        customer_tattle_uuid: Number(this.props.match.params.id),
        attribute_value: id,
        attribute_key: attribute_key,
        customer_tattle_uuid: this.state.rows.customer_tattle_uuid,
        user_uuid: this.state.boarddata.user_uuid,
      };

      const resp = await fetch(`${this.state.apiUrl}tattle/remove-item`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(inputs),
      });

      const redata = await resp.json();

      if (redata.code === 200) {
        this.setState((state) => {
          const newFieldArray = (state.rows[attribute_key] || []).filter(
            (item) => item?.trim() !== id?.trim() && item !== "",
          );
          return {
            ...state,
            rows: {
              ...state.rows,
              [attribute_key]: newFieldArray,
            },
          };
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  getSlaMissedReasonByField = (fieldKey) => {
    const sla_missed_list = this.state.rows.sla_missed_list || [];
    const slaInfo = this.state.rows.sla_info || {};

    const slaMapped = sla_missed_list.reduce((acc, key) => {
      const mappedKey = slaInfo[key];
      if (mappedKey) {
        acc[mappedKey] = key;
      }
      return acc;
    }, {});

    const originalKey = slaMapped[fieldKey];
    return originalKey
      ? originalKey.replace(/_/g, " ").replace(/\ber\b/gi, "ER")
      : null;
  };

  debounceScroll = () => {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.scrollToTarget();
    }, 0); // Adjust the debounce delay as needed
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props !== prevProps) {
      if (this.props.attributes.status === 200) {
        let newvisited = {};
        let getvisited = localStorage.getItem("recentVisited");
        let visited = JSON.parse(getvisited);
        if (!!visited?.[this.getCommonData().app_token]) {
          const rVisit =
            visited[this.getCommonData().app_token][
              this.props.match.params.attribute_set_key
            ];
          setTimeout(() => {
            this.setState({ ...this.state, recentVisited: rVisit });
          });

          let datapush = [
            ...(visited[this.getCommonData().app_token][
              this.props.match.params.attribute_set_key
            ] || []),
          ];
          datapush.unshift(this.props.match.params.id);
          visited = {
            ...visited,
            [this.getCommonData().app_token]: {
              ...visited[this.getCommonData().app_token],
              [this.props.match.params.attribute_set_key]: [
                ...new Set(datapush),
              ],
            },
          };
          localStorage.setItem("recentVisited", JSON.stringify(visited));
        } else {
          let getvisited = localStorage.getItem("recentVisited");
          let visited = JSON.parse(getvisited);
          const newvisi = [];
          newvisi.push(this.props.match.params.id);
          newvisited = {
            ...visited,
            [this.getCommonData().app_token]: {
              [this.props.match.params.attribute_set_key]: newvisi,
            },
          };
          localStorage.setItem("recentVisited", JSON.stringify(newvisited));
        }
      }

      this.setState(
        {
          ...this.state,
          people: this.props.attributes.bord_details.people || [],
          details: this.props.attributes.bord_details.details || [],
          status: this.props.attributes.bord_details.status || [],
          attachment_pane: this.props.attributes.bord_details.attachment || [],
          hidden_panel: this.props.attributes.bord_details.hidden_panel || [],
          newMonitor: this.props.attributes.monitor,
          boardDetails: this.props.boardDetails,
          boarddata: {
            ...this.state.boarddata,
            ...this.props.boardData,
            ...this.getCommonData(),
          },
          boardName: {
            ...this.state.boardName,
            ...this.props.allBoard.nameboard,
          },
          title: this.props.attributes.bord_details.title || [],
          // history: this.props.attributes.history || [],
          notes: this.props.note.notes || [],
          long_text: this.props.attributes.bord_details.long_text || [],
          child_boards: this.props.attributes.child_board || [],
          description: this.props.attributes.bord_details.description || [],
          planning_date: this.props.attributes.bord_details.planning_date || [],
          feature: this.props.attributes.bord_details.feature || [],
          release_pane: this.props.attributes.bord_details.release_pane || [],
          dev_project_plan:
            this.props.attributes.bord_details.dev_project_plan || [],
          qa_project_plan:
            this.props.attributes.bord_details.qa_project_plan || [],
          scrum_project_plan:
            this.props.attributes.bord_details.scrum_project_plan || [],
          // rows: { ...this.props.attributes.rows } || {},
          users: this.props.users || {},
          loginData: this.props.logindata,
          loading: this.props.attributes.loading,
          // createBoard: {
          //   ...this.state.createBoard,
          //   board: this.props.attributes.board || this.props.note.board,
          //   message: this.props.attributes.message || this.props.note.message,
          //   title: this.props.attributes.title || this.props.note.title,
          // },
        },
        () => {
          if (this.state.scrollToView) {
            this.debounceScroll();
          }
          if (this.state.status?.length > 0) {
            this.setState((state) => {
              if (this.state.isStatusChanged) {
                return {
                  ...state,
                  selectStatus: {
                    ...state.selectStatus,
                    // ...this.state.pauseSelectStatus,
                  },
                };
              } else if (
                this.state.status?.[0].options?.find(
                  (item) =>
                    item.id === this.state.rows?.status ||
                    item._id === this.state.rows?.status,
                )
              ) {
                return {
                  ...state,
                  selectStatus: {
                    ...state.selectStatus,
                    ...this.state.status?.[0].options?.find(
                      (item) =>
                        item.id === this.state.rows?.status ||
                        item._id === this.state.rows?.status,
                    ),
                  },
                };
              } else {
                return {
                  ...state,
                  selectStatus: {
                    ...state.selectStatus,
                    ...this.props.attributes.bord_details.status?.[0].options?.find(
                      (item) => item.is_default,
                    ),
                  },
                };
              }
            });
          }
        },
      );
    }
  };
  getHistoryData = (history) => {
    const { attributes, data } = history;
    this.setState((state) => {
      return {
        ...state,
        history: data,
        history_attributes: attributes,
      };
    });
  };
  convertToRawContent = (raw) => {
    const { blocks, entityMap } = raw;
    let content = "";
    Object.keys(blocks).map((i) => {
      const { entityRanges, text } = blocks[i];
      const textLength = text.length;

      let startRange = 0;
      entityRanges.map((range) => {
        content += text.substr(startRange, range.offset - startRange);
        content += '<a href="">';
        content += text.substr(range.offset, range.length);
        content += "</a>";
        startRange = range.offset + range.length;
      });
      content += text.substr(startRange, textLength);
      content += "\r\n";
    });

    return content;
  };
  componentWillUnmount = () => {
    this.props.clearBoardData();
  };

  fetchNotesPermission = () => {
    var user_details = this.getCommonData().user_details;
    var user_uuid = this.getCommonData().user_uuid;
    let is_external;
    let notes_permission;
    let note_ui;
    let note_type = this.state.note_type;
    let logged_in_user_detail;
    if (typeof user_details === "string") {
      user_details = JSON.parse(this.getCommonData().user_details);
      logged_in_user_detail = user_details.find(
        (item) =>
          item.user_uuid === this.getCommonData().user_uuid &&
          item.app_token === this.getCommonData().app_token,
      );

      is_external = logged_in_user_detail.is_external;

      if (
        this.state.boarddata.notes_permission == "" ||
        this.state.boarddata.notes_permission == null
      ) {
        notes_permission = "";
      } else {
        if (is_external == 1) {
          notes_permission =
            this.state.boarddata.notes_permission.permission.external_user;
        } else {
          notes_permission =
            this.state.boarddata.notes_permission.permission.internal_user;
        }
      }
      //            notes_permission = (this.state.boarddata.notes_permission !== "" || this.state.boarddata.notes_permission !== null)  ? is_external == 1 ? this.state.boarddata.notes_permission.permission.external_user : this.state.boarddata.notes_permission.permission.internal_user:[];
      note_ui = this.state.boarddata.notes_permission?.note_properties;
      note_type = is_external == 1 ? "external" : "internal";
    }
    this.setState(
      { is_external, notes_permission, note_ui, note_type },
      function () {},
    );
  };

  changeNoteType = (evt) => {
    this.setState({ note_type: evt.target.name });
  };

  getFieldCondition = (field, attributeConfig) => {
    if (!attributeConfig) return null;

    return attributeConfig[field] || null;
  };

  componentDidMount = async () => {
    this.props.stopPopup();
    this.props.checkSidebarLink(this.props.match.params.attribute_set_key);
    const getBoardData = await this.props.getBoardDetailsActions(
      this.props?.match?.params?.attribute_set_key,
    );
    this.fetchNotesPermission();
    setTimeout(() => {
      this.setState(
        {
          ...this.state,
          boarddata: { ...getBoardData?.data?.[0], ...this.getCommonData() },
          scrollSpec: true,
        },
        async () => {
          var title = this.props.title ? this.props.title : "";
          document.title = `${this.props.match.params.id} | ${this.state.boarddata.attribute_set_name}`;

          const boarddetails = {
            app_token: this.state.boarddata.app_token,
            attribute_set_key: this.props.match.params.attribute_set_key,
            customer_tattle_uuid: Number(this.props.match.params.id),
            attribute_set_type: this.state.boarddata.attribute_set_type,
          };
          const status = await this.props.getBoardAttributes(boarddetails);
          this.childLoading(false);
          if (status.code === 200) {
            this.setState((state) => {
              return {
                ...state,
                rows: status.data.rows,
                board_attributes: status.data.attributes,
              };
            });
          }
          if (status.code === 400) {
            if (this.state.boarddata.has_parent) {
              const url = `/tattle/${this.state.boarddata?.parent_attribute_set_key}/list`;
              this.props.history.push(url);
            }
            this.props.history.push("list");
            return;
          }
          this.props.callUserApi(this.getCommonData().app_token);
          this.props.getNote({
            app_token: this.state.boarddata.app_token,
            attribute_set_key: this.props.match.params.attribute_set_key,
            customer_tattle_uuid: Number(this.props.match.params.id),
            attribute_set_type: this.state.boarddata.attribute_set_type,
            is_external: this.state.is_external,
          });

          this.setState({ scrollToView: true });
        },
      );
    });
  };

  setupErrorHandler = (index, type, errors) => {
    this.apperror.current = type;
    return;
  };

  showInlineHandler = (index, type, obj) => {
    if (this.apperror?.current?.isValid === false) return;

    if (type === "release_pane") {
      const allattr = [...this.state.release_pane];
      const ind = allattr.findIndex((it) => it.showInlineEdit === true);
      if (ind > -1) {
        delete allattr[ind].showInlineEdit;
      }

      allattr[index].showInlineEdit = true;
      this.setState({
        ...this.state,
        release_pane: allattr,
      });
      return;
    }
    if (type === "details") {
      const allattr = [...this.state.details];
      const ind = allattr.findIndex(
        (it) => it.showInlineEdit === true && it.newerror.isValid === true,
      );
      if (ind > -1) {
        delete allattr[ind].showInlineEdit;
      }

      allattr[index].showInlineEdit = true;
      this.setState({
        ...this.state,
        details: allattr,
      });
    }
    if (type === "feature") {
      const allattr = [...this.state.feature];
      const ind = allattr.findIndex(
        (it) => it.showInlineEdit === true && it.newerror.isValid === true,
      );
      if (ind > -1) {
        delete allattr[ind].showInlineEdit;
      }

      allattr[index].showInlineEdit = true;
      this.setState({
        ...this.state,
        feature: allattr,
      });
    }
    if (type === "hidden_panel") {
      const allattr = [...this.state.hidden_panel];

      const ind = allattr?.findIndex(
        (it) => it.showInlineEdit === true && it.newerror?.isValid === true,
      );
      if (ind > -1) {
        delete allattr[ind].showInlineEdit;
      }

      allattr[index].showInlineEdit = true;
      this.setState({
        ...this.state,
        hidden_panel: allattr,
      });
    }
    if (type === "people") {
      const peop = [...this.state.people];
      const ind = peop.findIndex((it) => it.showInlineEdit === true);
      if (ind > -1) {
        delete peop[ind].showInlineEdit;
      }
      peop[index].showInlineEdit = true;
      this.setState({
        ...this.state,
        people: peop,
      });
    }

    if (type === "planning_date") {
      const dateplan = [...this.state.planning_date];
      const ind = dateplan.findIndex((it) => it.showInlineEdit === true);
      if (ind > -1) {
        delete dateplan[ind].showInlineEdit;
      }
      dateplan[index].showInlineEdit = true;
      this.setState({
        ...this.state,
        planning_date: dateplan,
      });
    }
    if (type === "dev_project_plan") {
      const dateplan = [...this.state.dev_project_plan];

      const ind = dateplan.findIndex((it) => it.showInlineEdit === true);

      if (ind > -1) {
        delete dateplan[ind].showInlineEdit;
      }
      dateplan[index].showInlineEdit = true;
      this.setState({
        ...this.state,
        dev_planning_date: dateplan,
      });
    }
    if (type === "qa_project_plan") {
      const dateplan = [...this.state.qa_project_plan];

      const ind = dateplan.findIndex((it) => it.showInlineEdit === true);

      if (ind > -1) {
        delete dateplan[ind].showInlineEdit;
      }
      dateplan[index].showInlineEdit = true;
      this.setState({
        ...this.state,
        qa_planning_date: dateplan,
      });
    }
    if (type === "scrum_project_plan") {
      const dateplan = [...this.state.scrum_project_plan];

      const ind = dateplan.findIndex((it) => it.showInlineEdit === true);

      if (ind > -1) {
        delete dateplan[ind].showInlineEdit;
      }
      dateplan[index].showInlineEdit = true;
      this.setState({
        ...this.state,
        scrum_planning_date: dateplan,
      });
    }

    if (type === "title") {
      const titleinl = [...this.state.title];
      const ind = titleinl.findIndex((it) => it.showInlineEdit === true);
      if (ind > -1) {
        delete titleinl[ind].showInlineEdit;
      }
      titleinl[index].showInlineEdit = true;
      this.setState({
        ...this.state,
        title: titleinl,
      });
      setTimeout(() => {
        this.titleEditFocus.current?.focus();

        this.setState({
          ...this.state,
          currentTitleValue: this.titleEditFocus.current.value,
        });
      });
    }
  };

  removeAllEditInline = (type, evt = null) => {
    if (type === "release_pane") {
      const plandate = [...this.state.release_pane];
      const newatte = plandate.map((item, index) => {
        delete item.showInlineEdit;
        return item;
      });
      this.setState({
        ...this.state,
        release_pane: newatte,
      });
    }
    if (type === "planning_date") {
      const plandate = [...this.state.planning_date];
      const newatte = plandate.map((item, index) => {
        delete item.showInlineEdit;
        return item;
      });
      this.setState({
        ...this.state,
        planning_date: newatte,
      });
    }
    if (type === "dev_project_plan") {
      const plandate = [...this.state.dev_project_plan];
      const newatte = plandate.map((item, index) => {
        delete item.showInlineEdit;
        return item;
      });
      this.setState({
        ...this.state,
        dev_project_plan: newatte,
      });
    }
    if (type === "qa_project_plan") {
      const plandate = [...this.state.qa_project_plan];
      const newatte = plandate.map((item, index) => {
        delete item.showInlineEdit;
        return item;
      });
      this.setState({
        ...this.state,
        qa_project_plan: newatte,
      });
    }
    if (type === "scrum_project_plan") {
      const plandate = [...this.state.scrum_project_plan];
      const newatte = plandate.map((item, index) => {
        delete item.showInlineEdit;
        return item;
      });
      this.setState({
        ...this.state,
        scrum_project_plan: newatte,
      });
    }
    if (type === "details") {
      const allremove = [...this.state.details];
      const newatte = allremove.map((item, index) => {
        if (
          item.newerror?.isValid === true ||
          item.newerror?.isValid === undefined
        ) {
          delete item.showInlineEdit;
          return item;
        } else {
          return item;
        }
      });
      this.setState({
        ...this.state,
        details: newatte,
      });
    }
    if (type === "feature") {
      const allremove = [...this.state.feature];
      const newatte = allremove.map((item, index) => {
        if (
          item.newerror?.isValid === true ||
          item.newerror?.isValid === undefined
        ) {
          delete item.showInlineEdit;
          return item;
        } else {
          return item;
        }
      });
      this.setState({
        ...this.state,
        feature: newatte,
      });
    }
    if (type === "hidden_panel") {
      const allremove = [...this.state.hidden_panel];
      const newatte = allremove.map((item, index) => {
        if (
          item.newerror?.isValid === true ||
          item.newerror?.isValid === undefined
        ) {
          delete item.showInlineEdit;
          return item;
        } else {
          return item;
        }
      });
      this.setState({
        ...this.state,
        hidden_panel: newatte,
      });
    }

    if (type === "people") {
      const allremove = [...this.state.people];
      const newatte = allremove.map((item, index) => {
        delete item.showInlineEdit;
        return item;
      });
      this.setState({
        ...this.state,
        people: newatte,
      });
    }
    if (type === "title") {
      const titlerename = [...this.state.title];
      const titles = titlerename.map((item, index) => {
        delete item.showInlineEdit;
        return item;
      });
      this.setState(
        {
          ...this.state,
          title: titles,
        },
        () => {
          if (evt.target.value.trim() !== this.state.currentTitleValue.trim()) {
            this.dataSubmit({
              [evt.target.name]:
                this.state.rows?.title || this.state.rows?.name,
            });
          }
        },
      );
    }
  };

  checkValidationArray = (keys, dataarray) => {
    const ttt = this.state.rows[keys];
    if (Array.isArray(ttt)) {
      return ttt.every((it) => dataarray[keys].includes(it));
    } else {
      const conarr = JSON.parse(ttt);
      return conarr.every((ii) => dataarray[keys].includes(ii));
    }
  };

  dataSubmit = async (
    data,
    key = null,
    dat = null,
    url = null,
    calculate_effort = null,
  ) => {
    if (this.apperror?.current?.isValid === false) return;
    setTimeout(() => {
      this.setState((state) => {
        return {
          ...state,
          activeTabKey: "note",
        };
      });
    });
    try {
      if (data) {
        const checkassign = Object.keys(data);
        if (key === "toggle") {
          this.setState((state) => {
            return {
              ...state,
              rows: {
                ...state.rows,
                ...data,
              },
            };
          });

          const singleRow = {
            ...data,
            user_uuid: this.state.boarddata.user_uuid,
            attribute_set_key: this.props.match.params.attribute_set_key,
            app_token: this.state.boarddata.app_token,
            customer_tattle_uuid: this.props.match.params.id,
          };
          // console.log("4747", singleRow);

          const resdata = await apiHandler(key, singleRow);
          return;
        }
        if (key === "assign_to") {
          const assign_to_data = {
            attribute_set_key: this.props.match.params.attribute_set_key,
            app_token: this.state.boarddata.app_token,
            customer_tattle_uuid: +this.props.match.params.id,
            user_uuid: this.state.boarddata.user_uuid,
            attribute_type: "assign_to",
            attribute_key: "assign_to",
            attribute_value: data[checkassign[0]],
          };

          const resdata = await apiHandler(key, assign_to_data);

          if (resdata.code === 200) {
            this.setState((state) => {
              return {
                ...state,
                rows: {
                  ...state.rows,
                  assign_to: resdata?.data?.attribute_value,
                  has_sla: resdata?.data?.has_sla,
                  sla_fields: resdata?.data?.sla_fields,
                  sla_info: resdata?.data?.sla_info,
                  sla_missed_list: resdata?.data?.sla_missed_list,
                  sla_missed: resdata?.data?.sla_missed,
                  active_sla_list: resdata?.data?.active_sla_list,
                },
                // createBoard: {
                //   ...state.createBoard,
                //   message: resdata.message,
                //   title: resdata.status,
                //   bg: "primary",
                //   board: true,
                // },
              };
            });
          }
        } else if (key === "multi-select") {
          this.setState((state) => {
            return {
              ...state,
              rows: {
                ...state.rows,
                ...data,
              },
              // createBoard: {
              //   ...state.createBoard,
              //   message: resdata.message,
              //   title: resdata.status,
              //   bg: "primary",
              //   board: true,
              // },
            };
          });
          const singleRow = {
            ...data,
            user_uuid: this.state.boarddata.user_uuid,
            attribute_set_key: this.props.match.params.attribute_set_key,
            app_token: this.state.boarddata.app_token,
            customer_tattle_uuid: this.props.match.params.id,
          };
          // console.log("4747", singleRow);
          const resdata = await apiHandler(key, singleRow);
          return;
        } else if (key === "category") {
          this.disabledCategory();
          const catedata = {
            attribute_set_key: this.props.match.params.attribute_set_key,
            app_token: this.state.boarddata.app_token,
            customer_tattle_uuid: +this.props.match.params.id,
            user_uuid: this.state.boarddata.user_uuid,
            category_id: data[checkassign[0]],
            attribute_key: "category",
          };
          const rdata = await apiHandler(key, catedata);

          if (rdata.code == 200) {
            const newrows = { ...this.state.rows };
            const statuscopy = [...this.state.status];

            let newcopieddata = { ...this.state.status?.[0] };
            newcopieddata.options = rdata?.data?.workflow;
            newrows["category"] = rdata.data.category;
            this.setState(
              (state) => {
                return {
                  ...state,
                  rows: {
                    ...newrows,
                    next_response_timestamp:
                      rdata?.data?.next_response_timestamp,
                    sla_missed: rdata?.data?.sla_missed,
                    has_sla: rdata?.data?.has_sla,
                    sla_fields: rdata?.data?.sla_fields,
                  },
                  status: [{ ...newcopieddata }],
                  isChangingCategory: false,
                  // createBoard: {
                  //   ...state.createBoard,
                  //   message: rdata.message,
                  //   title: rdata.status,
                  //   bg: "primary",
                  //   board: true,
                  // },
                };
              },
              async () => {
                this.setState((state) => {
                  return {
                    ...state,
                    isCallingBoard: true,
                    rows: {
                      ...state.rows,
                      has_sla: rdata?.data?.has_sla,
                      sla_fields: rdata?.data?.sla_fields,
                      sla_info: rdata?.data?.sla_info,
                      sla_missed_list: rdata?.data?.sla_missed_list,
                      sla_missed: rdata?.data?.sla_missed,
                      active_sla_list: rdata?.data?.active_sla_list,
                    },
                  };
                });
                const childboardresponse = await fetch(
                  `${this.state.apiUrl}tattle/get-child-boards`,
                  {
                    method: "POST",
                    body: JSON.stringify({
                      app_token: this.getCommonData().app_token,
                      attribute_set_key:
                        this.props.match.params.attribute_set_key,
                      customer_tattle_uuid: +this.props.match.params.id,
                    }),
                  },
                );

                const rdatachild = await childboardresponse.json();
                if (rdatachild.code == 200) {
                  this.setState((state) => {
                    return {
                      ...state,
                      child_boards: rdatachild.data,
                      isCallingBoard: false,
                    };
                  });
                }
              },
            );
          }
        } else if (key === "effort") {
          const singleRow = {
            effort_data: {
              ...data,
            },
            calculate_effort: calculate_effort,
            user_uuid: this.state.boarddata.user_uuid,
            attribute_set_key: this.props.match.params.attribute_set_key,
            app_token: this.state.boarddata.app_token,
            customer_tattle_uuid: +this.props.match.params.id,
          };
          const rdata = await apiHandler(key, singleRow);
          if (rdata.code == 200) {
            const rows = { ...this.state.rows };
            rows[dat] = rdata.data;
            this.setState((state) => {
              return {
                ...state,
                rows: {
                  ...rows,
                  next_response_timestamp: rdata?.data?.next_response_timestamp,
                  has_sla: rdata?.data?.has_sla,
                  sla_fields: rdata?.data?.sla_fields,
                  sla_missed: rdata?.data?.sla_missed,
                  sla_info: rdata?.data?.sla_info,
                  sla_missed_list: rdata?.data?.sla_missed_list,
                  active_sla_list: rdata?.data?.active_sla_list,
                  ...(rdata?.data?.qa_effort &&
                  (typeof rdata?.data?.qa_effort !== "object" ||
                    Object.keys(rdata?.data?.qa_effort).length > 0)
                    ? { qa_effort: rdata?.data?.qa_effort }
                    : {}),
                },
              };
            });
          }
        } else if (key === "external_api" && url) {
          const singleRow = {
            ...data,
            user_uuid: this.state.boarddata.user_uuid,
            attribute_set_key: this.props.match.params.attribute_set_key,
            app_token: this.state.boarddata.app_token,
            customer_tattle_uuid: Number(this.props.match.params.id),
          };
          const rdata = await apiHandler(key, singleRow, url);
          if (rdata.code === 200) {
            this.setState(
              (state) => {
                return {
                  ...state,
                  rows: {
                    ...state.rows,
                    ...data,
                    ...rdata?.data,
                  },
                };
              },
              // async () => {
              //   const ndata = await this.props.getBoardHistory(
              //     {
              //       app_token: this.state.boarddata.app_token,
              //       attribute_set_key:
              //         this.props.match.params.attribute_set_key,
              //       customer_tattle_uuid: Number(this.props.match.params.id),
              //     },
              //     "status"
              //   );
              //   if (ndata.code == 200) {
              //     this.setState((state) => {
              //       return {
              //         ...state,
              //         history: ndata?.data,
              //         history_attributes: ndata?.attributes,
              //       };
              //     });
              // } else {
              //   this.setState((state) => {
              //     return {
              //       ...state,
              //       history: [],
              //       history_attributes: [],
              //     };
              //   });
              // }
              // }
            );
          }

          return;
        } else if (key === "release") {
          const singleRow = {
            ...data,
            user_uuid: this.state.boarddata.user_uuid,
            attribute_set_key: this.props.match.params.attribute_set_key,
            app_token: this.state.boarddata.app_token,
            customer_tattle_uuid: [+this.props.match.params.id],
          };
          const rdata = await apiHandler(key, singleRow);
          if (rdata.code == 200) {
            const rows = { ...this.state.rows };
            rows[dat] = rdata.data;
            this.setState((state) => {
              return {
                ...state,
                rows: {
                  ...state.rows,
                  ...data,
                  next_response_timestamp: rdata?.data?.next_response_timestamp,
                  has_sla: rdata?.data?.has_sla,
                  sla_fields: rdata?.data?.sla_fields,
                  sla_missed: rdata?.data?.sla_missed,
                  sla_info: rdata?.data?.sla_info,
                  sla_missed_list: rdata?.data?.sla_missed_list,
                  active_sla_list: rdata?.data?.active_sla_list,
                },
              };
            });
          }
          return;
        } else {
          this.setState((state) => {
            return {
              ...state,
              activeTabKey: "note",
            };
          });
          const keys = Object.keys(data);

          // if (Object.keys(data).length !== 0 && data?.[keys]?.length !== 0) {
          let checkvalid = true;
          const singleRow = {
            ...data,
            user_uuid: this.state.boarddata.user_uuid,
            attribute_set_key: this.props.match.params.attribute_set_key,
            app_token: this.state.boarddata.app_token,
            customer_tattle_uuid: this.props.match.params.id,
          };
          // console.log("4747", singleRow);
          const resdata = await apiHandler("", singleRow);
          // const ndata = await this.props.getBoardHistory(
          //   {
          //     app_token: this.state.boarddata.app_token,
          //     attribute_set_key: this.props.match.params.attribute_set_key,
          //     customer_tattle_uuid: Number(this.props.match.params.id),
          //   },
          //   "status"
          // );
          // if (ndata.code == 200) {
          //   this.setState((state) => {
          //     return {
          //       ...state,
          //       history: ndata?.data,
          //       history_attributes: ndata?.attributes,
          //     };
          //   });
          // } else {
          //   this.setState((state) => {
          //     return {
          //       ...state,
          //       history: [],
          //       history_attributes: [],
          //     };
          //   });
          // }

          if (resdata.code === 200) {
            this.setState((state) => {
              return {
                ...state,
                rows: {
                  ...state.rows,
                  ...data,
                  next_response_timestamp:
                    resdata?.data?.next_response_timestamp,
                  has_sla: resdata?.data?.has_sla,
                  sla_missed: resdata?.data?.sla_missed,
                  sla_fields: resdata?.data?.sla_fields,
                  sla_info: resdata?.data?.sla_info,
                  sla_missed_list: resdata?.data?.sla_missed_list,
                  active_sla_list: resdata?.data?.active_sla_list,
                },
                // createBoard: {
                //   ...state.createBoard,
                //   message: resdata.message,
                //   title: resdata.status,
                //   bg: "primary",
                //   board: true,
                // },
              };
            });
          }
        }
      }
      // }
    } catch (error) {
      console.log(error);
    }
  };

  submitProjectHandler = async (data, attrtype) => {
    const keys = Object.keys(data);
    const values = Object.values(data);
    if (Object.keys(data).length > 0) {
      const erdata = {
        app_token: this.state.boarddata.app_token,
        user_uuid: this.state.boarddata.user_uuid,
        attribute_set_key: this.props.match.params.attribute_set_key,
        customer_tattle_uuid: +this.props.match.params.id,
        [attrtype]: {
          ...data,
        },
      };
      const rdata = await this.props.relateViceVersa(erdata, "status");
      this.setState((state) => {
        return {
          ...state,
          activeTabKey: "note",
        };
      });
      if (rdata.code == 200) {
        this.setState(
          (state) => {
            return {
              ...state,
              rows: {
                ...state.rows,
                [keys[0]]: rdata?.project || [],
                type: rdata.type || "",
                has_sla: rdata.data?.has_sla || false,
                sla_missed: rdata.data?.sla_missed || false,
                sla_fields: rdata.data?.sla_fields || [],
                sla_info: rdata.data?.sla_info || [],
                sla_missed_list: rdata.data?.sla_missed_list || [],
                active_sla_list: rdata.data?.active_sla_list || [],
              },
              // createBoard: {
              //   ...state.createBoard,
              //   board: true,
              //   message: rdata.message,
              //   title: rdata.status,
              //   bg: "primary",
              // },
            };
          },
          //   async () => {
          //     const data = await this.props.getBoardHistory(
          //       {
          //         app_token: this.state.boarddata.app_token,
          //         attribute_set_key: this.props.match.params.attribute_set_key,
          //         customer_tattle_uuid: Number(this.props.match.params.id),
          //       },
          //       "status"
          //     );
          //     if (data.code == 200) {
          //       this.setState((state) => {
          //         return {
          //           ...state,
          //           history: data?.data,
          //           history_attributes: data?.attributes,
          //         };
          //       });
          //     } else {
          //       this.setState((state) => {
          //         return {
          //           ...state,
          //           history: [],
          //           history_attributes: [],
          //         };
          //       });
          //     }
          //   }
        );
      } else {
        this.setState((state) => {
          return {
            ...state,
            createBoard: {
              ...state.createBoard,
              board: true,
              message: rdata.message,
              title: rdata.status,
              bg: "danger",
            },
          };
        });
      }
    }
  };

  getToolBarData = (field, data) => {
    try {
      this.setState((state) => ({
        ...state,
        rows: {
          ...state.rows,
          [field]: data,
        },
      }));
      this.dataSubmit({ [field]: data }, field, data);
    } catch (err) {
      console.log(err);
    }
  };

  createFilter = (filterType) => {
    this.props.history.push("list", { page: "view", filterType: filterType });
  };
  previewImage = (image_url) => {
    const exten = image_url.split(".").pop();
    const checkexten = ["pdf", "docx", "csv", "mp4"];
    if (!checkexten.includes(exten)) {
      const image_window = window.open("", "_blank");
      image_window.document.write(`
          <html>
            <body>
              <img src=${image_url} alt="Example" height="100%" width="100%">
            </body>
          </html>
    `);
    } else {
      window.open(image_url, "_blank");
    }
  };

  selectStatusChange = (item) => {
    if (this.apperror?.current?.isValid === false) return;
    setTimeout(() => {
      this.setState((state) => {
        return {
          ...state,
          activeTabKey: "note",
        };
      });
    });
    if (item.is_pause) {
      this.hideDropdown();

      this.setState((state) => {
        return {
          ...state,
          pauseSelectStatus: { ...item },
          reasonModal: true,
          isStatusChanged: true,
        };
      });

      return;
    }

    if (item.has_dependencies) {
      const defaultDependencies = {
        architecture_diagram: {
          can_empty: true,
        },
        impact_analysis: {
          can_empty: true,
        },
      };

      const deps = item.dependencies || defaultDependencies;
      const visibleDeps = getVisibleDependencies(deps, this.state.rows, item);

      // If at least one form field condition satisfies (or condition not there show default), show modal
      if (Object.keys(visibleDeps).length > 0) {
        this.hideDropdown();

        this.setState((state) => {
          return {
            ...state,
            has_dependencies: true,
            dependencies: deps,
            dependencySelectStatus: { ...item },
            isStatusDependency: true,
            pendingDependencyEdit: null,
            dependencyModalTitle: "Update required for the below fields",
          };
        });

        return;
      }
    }

    this.setState(
      {
        ...this.state,
        selectStatus: { ...item },
        buttonDisabledStatus: true,
        isStatusChanging: true,
      },
      async () => {
        try {
          this.hideDropdown();
          const formdata = {
            app_token: this.state.boarddata.app_token,
            user_uuid: this.state.boarddata.user_uuid,
            attribute_set_key: this.props.match.params.attribute_set_key,
            customer_tattle_uuid: +this.props.match.params.id,
            attribute_key: "status",
            status_id: item.id || item._id,
          };
          const rdata = await apiHandler("status", formdata);
          if (rdata.code === 200) {
            setTimeout(() => {
              this.setState({
                ...this.state,
                status: rdata?.data?.workflow,
                currentSelectedStatusName: rdata?.data[item.id || item._id],
                selectStatus: {
                  ...rdata?.data?.workflow?.find(
                    (item) =>
                      item.id === rdata?.data?.current_status ||
                      item._id === rdata?.data?.current_status,
                  ),
                },
                buttonDisabledStatus: false,
                rows: {
                  ...this.state.rows,
                  has_sla: rdata?.data?.has_sla,
                  sla_missed: rdata?.data?.sla_missed,
                  sla_fields: rdata?.data?.sla_fields || [],
                  sla_info: rdata?.data?.sla_info || [],
                  sla_missed_list: rdata?.data?.sla_missed_list || [],
                  active_sla_list: rdata?.data?.active_sla_list || [],
                  next_response_timestamp: rdata?.data?.next_response_timestamp,
                },

                // createBoard: {
                //   ...this.state.createBoard,
                //   board: true,
                //   message: rdata.message,
                //   title: rdata.status,
                //   code: "status-change",
                // },
              });
            });
            setTimeout(async () => {
              this.setState((state) => {
                return {
                  ...state,
                  rows: {
                    ...state.rows,
                    status: item.id || item._id,
                  },
                  status: rdata?.data?.workflow,
                };
              });
              // this.props.updateStatusRow(item._id, rdata?.data?.workflow);

              // const data = await this.props.getBoardHistory(
              //   {
              //     app_token: this.state.boarddata.app_token,
              //     attribute_set_key: this.props.match.params.attribute_set_key,
              //     customer_tattle_uuid: Number(this.props.match.params.id),
              //   },
              //   "status"
              // );
              // if (data.code == 200) {
              //   this.setState((state) => {
              //     return {
              //       ...state,
              //       history: data?.data,
              //       history_attributes: data?.attributes,
              //     };
              //   });
              // } else {
              //   this.setState((state) => {
              //     return {
              //       ...state,
              //       history: [],
              //       history_attributes: [],
              //     };
              //   });
              // }
            }, 2000);
          }
        } catch (error) {
          console.log(error.message);
        }
      },
    );
  };
  monitorModalClose = () => {
    this.setState({ ...this.state, showMonitor: false });
  };
  hideDropdown = () => {
    this.setState({ ...this.state, dropdown: false });
  };
  showDropdownHandler = () => {
    if (this.apperror?.current?.isValid === false) return;
    this.setState({ ...this.state, dropdown: true });
  };
  editDescriptionHandler = () => {
    if (this.apperror?.current?.isValid === false) return;

    this.setState({ ...this.state, descEdit: true });
  };

  onBlurClose = (item = null) => {
    let editlongtext = { ...this.state.long_text_edit };
    editlongtext[item.field] = false;
    setTimeout(() => {
      this.setState({
        ...this.state,
        descEdit: false,
        long_text_edit: editlongtext,
      });
    });
  };
  onRemoveEditAttachment = (editNoteId, imageId) => {
    const editingnotes = { ...this.state.editNote };
    editingnotes.attachment = {
      ...delete editingnotes["attachment"][imageId],
      ...editingnotes.attachment,
    };
    this.setState({ ...this.state, editNote: editingnotes });
  };

  checkError = () => {
    if (this.apperror?.current?.isValid === false) return;

    return true;
  };

  changeTheActiveTab = () => {
    this.setState((state) => {
      return {
        ...state,
        activeTabKey: "note",
      };
    });
  };

  titleChangeHandler = (evt) => {
    const { name, value } = evt.target;
    if (this.state.title[0].show_reason) {
      this.reasonAsking(
        "title",
        { ...this.state.title[0], title: this.state.rows["title"] },
        "title",
      );
      return;
    }
    if (value.trim()) {
      const rowss = { ...this.state.rows };
      rowss[name] = value;
      this.setState({ ...this.state, rows: rowss, validTitle: true });
    } else {
      const rowss = { ...this.state.rows };
      rowss[name] = value;
      this.setState({ ...this.state, rows: rowss, validTitle: false });
    }
  };

  saveInputTitle = () => {
    this.dataSubmit({ title: this.state.titleDetails });
  };
  showLongTextHandler = (item) => {
    let longTextdata = { ...this.state.isLongText };
    longTextdata[item.field] = {
      long: !this.state.isLongText[item.field]?.long,
    };
    this.setState((state) => {
      return {
        ...state,
        isLongText: longTextdata,
      };
    });
  };
  getTitleBoard = (title) => {
    if (title.length > 0) {
      if (title[0].showInlineEdit) {
        return (
          <div className="title-view">
            <input
              type="text"
              className="form-control w-100"
              ref={this.titleEditFocus}
              value={this.state.rows[title[0].field]}
              onChange={this.titleChangeHandler}
              name={title[0].field}
              onBlur={(evt) => {
                this.state.validTitle && this.removeAllEditInline("title", evt);
              }}
            />
            <div className="feedback">
              {!this.state.validTitle && "Title is required"}
            </div>
          </div>
        );
      } else {
        return (
          <span
            onClick={() =>
              !title?.[0]?.readonly && this.showInlineHandler(0, "title")
            }
          >
            {this.state.rows && this.state?.rows[title[0]?.field]}
          </span>
        );
      }
    }
  };

  historyApiCall = (evt) => {
    if (evt === "tattleHistory") {
      this.setState(
        (state) => {
          return {
            ...state,
            history: [],
            activeTabKey: "tattleHistory",
          };
        },
        async () => {
          const newevtdata = await this.props.getBoardHistory(
            {
              app_token: this.state.boarddata.app_token,
              attribute_set_key: this.props.match.params.attribute_set_key,
              customer_tattle_uuid: Number(this.props.match.params.id),
              attribute_set_type: this.state.boarddata.attribute_set_type,
            },
            "status",
          );

          if (newevtdata.code == 200) {
            this.setState((state) => {
              return {
                ...state,
                history: newevtdata?.data,
                history_attributes: newevtdata?.attributes,
              };
            });
          }
        },
      );
    } else {
      this.setState((state) => {
        return {
          ...state,
          activeTabKey: "note",
        };
      });
    }
  };
  // get Users name

  getUserName = (userid) => {
    let userlist = this.state.users;

    return userlist[userid] ? userlist[userid].name : "";
  };

  getProfileImage = (userid) => {
    let userlist = this.state.users;

    return userlist[userid] ? userlist[userid].profile_image : "";
  };

  AddMonitorHandler = (data) => {
    if (this.apperror?.current?.isValid === false) return;
    // this.props.enableMonitoring();
    this.setState({
      ...this.state,
      showMonitor: true,
      isMultiple: data.is_multiple,
    });
  };

  /* changeInternalHandler = (evt) => {
    const { name, checked } = evt.target;
    if (name === "customer") {
      this.setState({
        ...this.state,
        noteType: {
          ...this.state.noteType,
          is_customer: checked,
          is_internal: false,
        },
      });
    } else {
      this.setState({
        ...this.state,
        noteType: {
          ...this.state.noteType,
          is_internal: checked,
          is_customer: false,
        },
      });
    }
  };*/

  getAttachmentList = (item) => {
    if (
      item.hasOwnProperty("attachment") &&
      typeof item["attachment"] === "object"
    ) {
      return (
        <div class="afterupload-image">
          {item.hasOwnProperty("attachment")
            ? Object.keys(item["attachment"]).map((itt, inn) => {
                return (
                  <div
                    class="img-box"
                    key={inn}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <ImagePreview
                      itt={itt}
                      item={item}
                      imgLength={Object.keys(item["attachment"]).map(
                        (ite) => item["attachment"][ite],
                      )}
                      width="128px"
                      height="58px"
                    />
                    <figure>
                      {item?.["attachment"][itt]?.file_name?.slice(0, 7) +
                        "." +
                        item?.["attachment"][itt]?.file_name?.split(".")?.pop()}
                    </figure>
                  </div>
                );
              })
            : null}
        </div>
      );
    }
  };

  removeMonitorHandler = async (remove) => {
    if (remove.length > 0) {
      const redata = await this.props.removeMonitoring(
        {
          app_token: this.state.boarddata.app_token,
          user_uuid: this.state.boarddata.user_uuid,
          attribute_set_key: this.props.match.params.attribute_set_key,
          customer_tattle_uuid: this.props.match.params.id,
          attribute_type: "monitoring",
          attribute_key: "monitoring",
          attribute_value: remove,
        },
        "status",
      );
      if (redata?.code == 200) {
        let newusers = [...this.state.newMonitor];
        let newfilusers = newusers.filter(
          (item) => !redata?.data?.attribute_value.includes(item),
        );

        this.setState(
          (state) => {
            return {
              ...state,
              newMonitor: newfilusers,
              showMonitor: false,
            };
          },
          async () => {
            const ndata = await this.props.getBoardHistory(
              {
                app_token: this.state.boarddata.app_token,
                attribute_set_key: this.props.match.params.attribute_set_key,
                customer_tattle_uuid: Number(this.props.match.params.id),
              },
              "status",
            );
            if (ndata.code == 200) {
              this.setState((state) => {
                return {
                  ...state,
                  history: ndata?.data,
                  history_attributes: ndata?.attributes,
                };
              });
            } else {
              this.setState((state) => {
                return {
                  ...state,
                  history: [],
                  history_attributes: [],
                };
              });
            }
          },
        );
      }
    }
  };
  getNoteAndImage = (item, user = null) => {
    let users = this.state.users;
    return (
      <>
        <div class="topPart d-flex justify-content-start align-items-center">
          <div class="left-side firstLetter">
            {item.note_type === "internal_email" ? (
              <img src={`${item?.user_details?.profile_image}`} />
            ) : (
              <img
                src={`${
                  user?.profile_image || users[item.user_uuid]?.profile_image
                }`}
              />
            )}
          </div>
          <div class="right-side">
            <div class="name">
              {item.note_type === "internal_email" ? (
                item?.user_details?.name
              ) : users[item.user_uuid]?.profile_url ? (
                <a
                  target={"_blank"}
                  href={users[item.user_uuid]?.profile_url}
                  className="checkUserNameNote"
                >
                  {" "}
                  {users[item.user_uuid]?.name}
                </a>
              ) : (
                user?.name || users[item.user_uuid]?.name
              )}
              {/*this.state.boarddata.attribute_set_type === 2 && (
                <span>
                  {item.note_type == "external"
                    ? "To Customer"
                    : item.note_type}
                </span>
              )*/}
              {this.state.notes_permission &&
              this.state.notes_permission.hasOwnProperty("can_view") ? (
                <span>
                  {this.state.note_ui &&
                    this.state.note_ui?.[item.note_type] &&
                    this.state.note_ui?.[item.note_type]?.list_label}
                </span>
              ) : (
                ""
              )}
            </div>

            <div class="noteDesc self">
              Note{" "}
              <Link
                to={`#note${item?.custom_note_uuid || item?.id || item?._id}`}
                className="note-link"
              >
                {item?.custom_note_uuid || item?.id || item?._id}
              </Link>
              &nbsp;&nbsp; | &nbsp;&nbsp;
              {this.isDateTimeValid(
                item?.updated_timestamp || item?.created_timestamp,
              ) ? (
                <>
                  <DateTimeDisplay
                    dateTime={
                      item?.updated_timestamp || item?.created_timestamp
                    }
                  />
                </>
              ) : (
                ""
              )}{" "}
              &nbsp; | &nbsp;
              <CopyLinkItem
                item={item}
                attribute_set_key={this.props.match.params.attribute_set_key}
              />
            </div>
          </div>
        </div>
      </>
    );
  };

  // adding monitor
  addingNewMonitorHandler = async (id, monitor) => {
    this.setState((state) => {
      return {
        ...state,
        isAddingButton: true,
      };
    });
    const monitoringdata = {
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.attribute_set_key,
      customer_tattle_uuid: +id,
      attribute_type: "monitoring",
      attribute_key: "monitoring",
      attribute_value: monitor,
    };
    const data = await this.props.addMonitoring(monitoringdata, "status");
    this.setState((state) => {
      return {
        ...state,
        activeTabKey: "note",
      };
    });
    if (data.code == 200) {
      this.setState(
        (state) => {
          return {
            ...state,
            newMonitor: data?.data?.attribute_value,
            showMonitor: false,
            isAddingButton: false,
          };
        },
        // async () => {
        //   const ndata = await this.props.getBoardHistory(
        //     {
        //       app_token: this.state.boarddata.app_token,
        //       attribute_set_key: this.props.match.params.attribute_set_key,
        //       customer_tattle_uuid: Number(this.props.match.params.id),
        //     },
        //     "status"
        //   );
        //   if (ndata.code == 200) {
        //     this.setState((state) => {
        //       return {
        //         ...state,
        //         history: ndata?.data,
        //         history_attributes: ndata?.attributes,
        //       };
        //     });
        //   } else {
        //     this.setState((state) => {
        //       return {
        //         ...state,
        //         history: [],
        //         history_attributes: [],
        //       };
        //     });
        //   }
        // }
      );
    }
  };

  isValidJSON = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  showMoreAttributeHandler = () => {
    this.setState({
      ...this.state,
      show_more_attribute: !this.state.show_more_attribute,
    });
  };

  //notes

  getRawData = async (data, html, draft_js_content, images = []) => {
    try {
      if (this.apperror?.current?.isValid === false) return;

      this.setState((state) => {
        return {
          ...state,
          isAddingNote: true,
        };
      });

      let noteType;
      noteType = this.state.noteType.is_customer ? "external" : "internal";

      let addingnoterequest = {};

      addingnoterequest = {
        attribute_set_key: this.props.match.params.attribute_set_key,
        app_token: this.state.boarddata.app_token,
        customer_tattle_uuid: +this.props.match.params.id,
        user_uuid: this.state.boarddata.user_uuid,
        note_content: html,
        attribute_set_type: this.state.boarddata.attribute_set_type,
        note_content_json: data,
        //      note_type: noteType,
        note_type: this.state.note_type,
        is_external: this.state.is_external,
      };

      if (Object.keys(images).length > 0) {
        Object.assign(addingnoterequest, {
          attachment: JSON.stringify(images),
        });
      }

      if (draft_js_content?.length > 0) {
        draft_js_content.forEach((it) => {
          if (it.user_uuid) {
            Object.assign(addingnoterequest, {
              mention: (addingnoterequest.mention || []).concat(it.user_uuid),
            });
          }
        });
      }

      const resp = await this.props.addNote(addingnoterequest, "status");

      if (!resp) {
        this.setState((state) => {
          return {
            ...state,
            createBoard: {
              ...state.createBoard,
              board: true,
              bg: "danger",
              title: "Something Went Wrong",
              message: "Please try again after sometime",
            },
          };
        });
        return false;
      }

      if (resp?.code === 200) {
        const { data } = resp;

        let noteobj = {};

        if (data && data.hasOwnProperty("note_type")) {
          noteobj = {
            noteType: {
              ...this.state.note_type,
              is_internal: true,
            },
            note_type: "internal",
          };
        }

        this.setState(
          (state) => {
            return {
              ...state,
              isAddingNote: false,
              ...noteobj,
              rows: {
                ...state.rows,
                next_response_timestamp: data?.next_response_timestamp,
                has_sla: data?.has_sla,
                sla_missed: data?.sla_missed || false,
                sla_info: data?.sla_info || [],
                sla_missed_list: data?.sla_missed_list || [],
                active_sla_list: data?.active_sla_list || [],
                sla_fields: data?.sla_fields || [],
              },
            };
          },

          async () => {
            try {
              const rnote = await this.props.getNote(
                {
                  app_token: this.state.boarddata.app_token,
                  attribute_set_key: this.props.match.params.attribute_set_key,
                  customer_tattle_uuid: Number(this.props.match.params.id),
                  attribute_set_type: this.state.boarddata.attribute_set_type,
                  is_external: this.state.is_external,
                },
                "status",
              );

              if (rnote?.code == 200) {
                this.setState((state) => {
                  return {
                    ...state,
                    notes: rnote?.data.map((item) =>
                      item.hasOwnProperty("attachment")
                        ? {
                            ...item,
                            attachment: this.isValidJSON(item.attachment)
                              ? JSON.parse(item.attachment)
                              : item.attachment,
                          }
                        : { ...item },
                    ),
                  };
                });
              }
            } catch (error) {
              console.error(error);
              this.setState((state) => ({
                ...state,
                createBoard: {
                  ...state.createBoard,
                  board: true,
                  bg: "danger",
                  title: "Error",
                  message: error?.message || "Something went wrong",
                },
              }));
            }
          },
        );
        return true;
      } else {
        this.setState((state) => {
          return {
            ...state,
            createBoard: {
              ...state.createBoard,
              board: true,
              bg: "danger",
              title: resp?.status,
              message: resp?.message,
            },
          };
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({
        isAddingNote: false,
      });
    }
  };

  submitNote = async (
    val,
    json_content,
    id,
    custom_note_uuid,
    mentions,
    removeAttachment,
    newimages,
  ) => {
    try {
      let noteType;
      noteType = this.state.noteType.is_customer ? "external" : "internal";

      let addingnoterequest = {};

      addingnoterequest = {
        attribute_set_key: this.props.match.params.attribute_set_key,
        app_token: this.state.boarddata.app_token,
        customer_tattle_uuid: Number(this.props.match.params.id),
        user_uuid: this.state.boarddata.user_uuid,
        note_content: val,
        attribute_set_type: this.state.boarddata.attribute_set_type,
        note_content_json: json_content,
        //        note_type: noteType,
        note_type: this.state.note_type,
        note_uuid: id,
        is_external: this.state.is_external,
      };

      if (Object.keys(newimages).length > 0) {
        Object.assign(addingnoterequest, {
          attachment: JSON.stringify(newimages),
        });
      }
      if (mentions?.length > 0) {
        mentions.forEach((it) => {
          if (it) {
            Object.assign(addingnoterequest, {
              mentions: (addingnoterequest.mentions || []).concat(it),
            });
          }
        });
      }
      if (removeAttachment.length > 0) {
        removeAttachment.forEach((item, ind) =>
          Object.assign(addingnoterequest, {
            removeAttachment: (addingnoterequest.removeAttachment || []).concat(
              item,
            ),
          }),
        );
      }

      const response = await fetch(`${this.state.apiUrl}note/update`, {
        method: "post",
        body: JSON.stringify(addingnoterequest),
      });
      const rdata = await response.json();

      if (rdata.code === 200) {
        const ndata = await this.props.getBoardHistory(
          {
            app_token: this.state.boarddata.app_token,
            attribute_set_key: this.props.match.params.attribute_set_key,
            customer_tattle_uuid: Number(this.props.match.params.id),
            attribute_set_type: this.state.boarddata.attribute_set_type,
          },
          "status",
        );
        if (ndata.code == 200) {
          this.setState((state) => {
            return {
              ...state,
              history: ndata?.data,
              history_attributes: ndata?.attributes,
            };
          });
        } else {
          this.setState((state) => {
            return {
              ...state,
              history: [],
              history_attributes: [],
            };
          });
        }
        setTimeout(async () => {
          const newnote = await this.props.getNote(
            {
              app_token: this.state.boarddata.app_token,
              attribute_set_key: this.props.match.params.attribute_set_key,
              customer_tattle_uuid: Number(this.props.match.params.id),
              attribute_set_type: this.state.boarddata.attribute_set_type,
              is_external: this.state.is_external,
            },
            "status",
          );

          if (newnote.code === 200) {
            this.setState((state) => {
              return {
                ...state,
                notes:
                  newnote?.data.map((item) =>
                    item.hasOwnProperty("attachment")
                      ? {
                          ...item,
                          attachment: this.isValidJSON(item.attachment)
                            ? JSON.parse(item.attachment)
                            : item.attachment,
                        }
                      : { ...item },
                  ) || [],
              };
            });
          }
          // this.props.clearImageEdit();
        }, 1000);

        this.setState(
          {
            ...this.state,
            // createBoard: {
            //   ...this.state.createBoard,
            //   board: true,
            //   message: rdata.message,
            //   title: rdata.status,
            //   bg: "primary",
            // },
            isUpdate: false,
            editModal: false,
            editImages: [],
          },
          () => {
            setTimeout(async () => {
              const data = await this.props.stopPopup("status");

              if (data.board === false) {
                this.setState((state) => {
                  return {
                    ...state,
                    createBoard: {
                      ...state.createBoard,
                      board: false,
                      message: "",
                      title: "",
                      code: "",
                    },
                  };
                });
              }
            }, 3000);
          },
        );
        return rdata;
      } else {
        this.setState({
          ...this.state,
          createBoard: {
            ...this.state.createBoard,
            board: true,
            message: rdata.message,
            title: "Error",
            bg: "danger",
          },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  setImages = (images) => {
    this.setState({ ...this.state, editImages: images });
  };
  updateContent = (html, json, men, images) => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        updateContent: html,
        json_content: json,
        mentions: men,
      });
    });
  };
  hideUiModal = () => {
    this.setState({
      ...this.state,
      editModal: false,
      attachShow: false,
      attachments: [],
    });
    this.arrayNew = [];
  };
  handleEditModal = (id) => {
    if (this.apperror?.current?.isValid === false) return;

    const noteEdit = this.state.notes.find(
      (item) => item.id === id || item._id === id,
    );
    this.setState((state) => {
      return { ...state, editModal: !state.editModal, editNote: noteEdit };
    });
  };
  getCopyUrl = () => {
    this.setState({ ...this.state, copyActive: true }, () => {
      const { product, cms_url } = this.state.rows.customers;
      if (product === "49F37046FCD84520895FC18A4F5BFC8B" && !cms_url) {
        navigator.clipboard.writeText(
          `${process.env.REACT_APP_CMS_URL}${this.props.match.params.id}`,
        );
      } else if (product === "49F37046FCD84520895FC18A4F5BFC8B" && cms_url) {
        navigator.clipboard.writeText(
          `${cms_url}/ticket/viewTicket/id/${this.props.match.params.id}`,
        );
      } else {
        navigator.clipboard.writeText(
          `${process.env.REACT_APP_HELPCENTER_URL}${this.props.match.params.id}`,
        );
      }
    });
    setTimeout(() => {
      this.setState({ ...this.state, copyActive: false });
    }, 1000);
  };
  showModalAttach = () => {
    if (this.apperror?.current?.isValid === false) return;

    this.setState({ ...this.state, attachShow: true, attachments: [] });
  };
  getRecentVisited = () => {
    const links = this.state.recentVisited
      .slice(0, 6)
      .filter((item) => item !== this.props.match.params.id)
      .map((item, index, newitem) => {
        if (index === newitem.length - 1) {
          return (
            <>
              <Link target="_blank" to={`${item}`} key={index}>
                {item}
              </Link>
              &nbsp;
            </>
          );
        } else {
          return (
            <>
              <Link target="_blank" to={`${item}`} key={index}>
                {item}
              </Link>
              &nbsp;
              <span className="fw-bold">|&nbsp;</span>
            </>
          );
        }
      });
    return (
      <>
        <div className="leftText">Recently Visited</div>
        <div className="right-text">{links}</div>
      </>
    );
  };
  getErButton = () => {
    const link = process.env.REACT_APP_LOCAL_URL || "";
    const items = [
      ...(this.state.details || []),
      ...(this.state.release_pane || []),
      ...(this.state.people || []),
      ...(this.state.planning_date || []),
      ...(this.state.title || []),
      ...(this.state.description || []),
      ...(this.state.hidden_panel || []),
      ...(this.state.long_text || []),
      ...(this.state.dev_project_plan || []),
      ...(this.state.qa_project_plan || []),
      ...(this.state.scrum_project_plan || []),
    ];

    return items.map(
      (item, index) =>
        item.attribute_type === "project" && (
          <a
            className="cta"
            href={`//${link}/tattle/${item.field}/add/${this.props.match.params.attribute_set_key}/${this.props.match.params.id}`}
            key={item.field + index} // Use item.id if available, otherwise fallback to index
          >
            <span>
              <svg
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.5 4V0.5H3.5V4H0V5H3.5V8.5H4.5V5H8V4H4.5Z"
                  fill="#7C8086"
                ></path>
              </svg>
            </span>
            {item.headerName}
          </a>
        ),
    );
  };

  getCopyLinkButton = () => {
    return (
      <div
        className={`cta copyLink  ${this.state.copyActive ? "active" : ""}`}
        onClick={this.getCopyUrl}
      >
        <span>
          <svg
            width="12"
            height="11"
            viewBox="0 0 12 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.85772 4.64226C6.40267 4.1874 5.78562 3.93188 5.14223 3.93188C4.49884 3.93188 3.88178 4.1874 3.42674 4.64226L1.71069 6.35774C1.25564 6.81279 1 7.42997 1 8.07351C1 8.71705 1.25564 9.33423 1.71069 9.78928C2.16574 10.2443 2.78292 10.5 3.42646 10.5C4.07 10.5 4.68718 10.2443 5.14223 9.78928L5.99997 8.93153"
              stroke="#7C8086"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M5.14209 6.35772C5.59713 6.81257 6.21419 7.06809 6.85758 7.06809C7.50097 7.06809 8.11803 6.81257 8.57307 6.35772L10.2891 4.64223C10.7442 4.18718 10.9998 3.57 10.9998 2.92646C10.9998 2.28292 10.7442 1.66574 10.2891 1.21069C9.83406 0.755644 9.21688 0.5 8.57335 0.5C7.92981 0.5 7.31263 0.755644 6.85758 1.21069L5.99983 2.06844"
              stroke="#7C8086"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </span>
        Copy Link
      </div>
    );
  };
  getAttachmentButton = () => {
    {
      return this.state.attachment_pane?.map(
        (item) =>
          item.attribute_type === "attachment" && (
            <div
              className="cta"
              data-bs-toggle="modal"
              data-bs-target="#upUrfileNext"
              onClick={this.showModalAttach}
            >
              <span>
                <svg
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.780009 5.84692L4.9454 1.68153C5.37037 1.25656 5.94676 1.01781 6.54776 1.01781C7.14876 1.01781 7.72514 1.25656 8.15011 1.68153C8.57508 2.1065 8.81383 2.68289 8.81383 3.28388C8.81383 3.88488 8.57508 4.46127 8.15011 4.88624L3.34305 9.69239C3.17212 9.85748 2.94318 9.94883 2.70555 9.94677C2.46792 9.9447 2.24061 9.84939 2.07257 9.68135C1.90453 9.51331 1.80922 9.286 1.80715 9.04837C1.80509 8.81074 1.89644 8.5818 2.06153 8.41087L6.86768 3.60381C6.95023 3.51835 6.99591 3.40388 6.99487 3.28506C6.99384 3.16625 6.94618 3.05259 6.86216 2.96857C6.77815 2.88455 6.66449 2.8369 6.54567 2.83586C6.42686 2.83483 6.31239 2.88051 6.22692 2.96305L1.42077 7.77102C1.24765 7.93823 1.10956 8.13824 1.01456 8.35939C0.919562 8.58053 0.869559 8.81838 0.867467 9.05906C0.865376 9.29974 0.911238 9.53843 1.00238 9.76119C1.09352 9.98395 1.22811 10.1863 1.3983 10.3565C1.56849 10.5267 1.77088 10.6613 1.99364 10.7524C2.2164 10.8436 2.45509 10.8895 2.69577 10.8874C2.93644 10.8853 3.1743 10.8353 3.39544 10.7403C3.61659 10.6453 3.8166 10.5072 3.98381 10.3341L8.79087 5.5279C9.38578 4.93299 9.72 4.12612 9.72 3.28479C9.72 2.44346 9.38578 1.63659 8.79087 1.04168C8.19596 0.446766 7.38909 0.112549 6.54776 0.112549C5.70643 0.112549 4.89955 0.446766 4.30464 1.04168L0.138343 5.20616C0.0950617 5.24797 0.0605393 5.29797 0.03679 5.35326C0.0130406 5.40854 0.000539967 5.46801 1.71098e-05 5.52818C-0.000505747 5.58834 0.0109597 5.64802 0.0337447 5.70371C0.0565297 5.7594 0.0901779 5.80999 0.132726 5.85254C0.175274 5.89509 0.225869 5.92874 0.28156 5.95152C0.337251 5.97431 0.396922 5.98577 0.457092 5.98525C0.517261 5.98473 0.576724 5.97223 0.632011 5.94848C0.687298 5.92473 0.737301 5.89021 0.779103 5.84692H0.780009Z"
                    fill="#7C8086"
                  ></path>
                </svg>
              </span>
              Attach
            </div>
          ),
      );
    }
  };
  getInternalUi = () => {
    if (
      this.state.notes_permission &&
      this.state.notes_permission.hasOwnProperty("can_add")
    ) {
      return (
        <div className="d-flex">
          {this.state.notes_permission.can_add.map(
            (item, index) =>
              this.state.note_ui?.[item]?.visible && (
                <div className="form-check me-4">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={item}
                    id={item}
                    checked={item === this.state.note_type}
                    onChange={(evt) => this.changeNoteType(evt)}
                  />
                  <label className="form-check-label" for={item}>
                    {this.state.note_ui && this.state.note_ui[item].btn_label}
                  </label>
                </div>
              ),
          )}
        </div>
      );
    }
  };

  isDateTimeValid = (dateInput) => {
    const parseDate = new Date(dateInput);
    return !isNaN(dateInput) && parseDate.toString() !== "invalid date";
  };

  attachmentUploadHandler = (evt) => {
    const files = evt.target.files;
    const attachments = [...this.state.attachments];
    for (let i = 0; i < files.length; i++) {
      attachments.push(files[i]);
    }

    this.setState({ attachments: attachments });
  };

  //convert any size to mb kb or gb

  bytesToSize = (bytes) => {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes == 0) return "0 Byte";
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  };

  newPromiseUploader = (formdata) => {
    let newarr = [];
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.state.apiUrl}attachment/upload`, formdata, {
          headers: {
            "Content-Type": "multipart/formdata",
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            let images = { ...this.state.rows?.attachment };
            images = {
              ...images,
              ...resp.data?.data,
            };
            this.setState((state) => {
              return {
                ...state,
                rows: {
                  ...state.rows,
                  attachment: images,
                },
              };
            });
            resolve(resp);
          } else {
            reject(resp);
          }
        })
        .catch((error) => {
          const arrnewcon = [...this.arrayNew];
          if (arrnewcon.length > 0) {
            let newfile = arrnewcon.find((item) => {
              return (
                item.name.toLowerCase() ===
                formdata.get("image").name.toLowerCase()
              );
            });
            if (!newfile) {
              this.getStoreData({
                name: formdata.get("image").name,
                message: error.message,
              });
            }
          } else {
            this.getStoreData({
              name: formdata.get("image").name,
              message: error.message,
            });
          }
          reject(error);
        });
    });
  };

  getStoreData = (data) => {
    this.arrayNew.push(data);
    return;
  };

  onSubmitAttachmentHandler = async (evt) => {
    evt.preventDefault();

    if (this.state.attachments.length > 0) {
      this.setState((state) => {
        return {
          ...state,
          mainImageUpload: true,
        };
      });
      let newarray = [];
      const appPromis = this.state.attachments.map((file) => {
        let formdata = new FormData();
        formdata.append("app_token", this.state.boarddata.app_token);
        formdata.append("product_key", process.env.REACT_APP_PRODUCT_KEY);
        formdata.append(`image`, file);
        const result = this.newPromiseUploader(formdata);
        result.then((resp) => {
          if (resp.data.code === 400 || resp.data.code === 1208) {
            const arrnewcon = [...this.arrayNew];
            if (arrnewcon.length > 0) {
              let newfile = arrnewcon.find((item) => {
                return item.name.toLowerCase() === file.name.toLowerCase();
              });
              if (!newfile) {
                this.getStoreData({
                  name: file.name,
                  message: resp.data.message,
                });
              }
              // return;
            } else {
              this.getStoreData({
                name: file.name,
                message: resp.data.message,
              });
            }
          }
        });
        return result;
      });

      const request = await Promise.allSettled(appPromis);

      if (request.length > 0) {
        let newfilearray = {};
        request.forEach((it) => {
          if (it.status === "fulfilled") {
            const {
              data: { data },
            } = it.value;
            newfilearray = { ...newfilearray, ...data };
          } else {
          }
        });

        if (
          newfilearray &&
          request.every(
            (item) =>
              item.status === "fulfilled" && item.value.data.code === 200,
          )
        ) {
          setTimeout(() => {
            this.setState((state) => {
              return {
                ...state,
                attachments: [],
                attachShow: false,
                mainImageUpload: false,
              };
            });
          }, 200);

          this.props.saveAttachment({ attachments: newfilearray }, "status");
          this.props.updateAttachment(
            {
              attachment: newfilearray,
              app_token: this.state.boarddata.app_token,
              attribute_set_key: this.props.match.params.attribute_set_key,
              customer_tattle_uuid: +this.props.match.params.id,
            },
            "status",
          );
        } else {
          this.setState((state) => {
            return { ...state, attachShow: true, mainImageUpload: false };
          });
        }
      }
    }
  };

  removeImageHandler = (index, name) => {
    const images = [...this.state.attachments];
    images.splice(index, 1);
    const newarrremove = [...this.arrayNew];
    const indexr = newarrremove.findIndex((item) => item.name === name);
    newarrremove.splice(indexr, 1);
    this.arrayNew = newarrremove;
    this.setState({ ...this.state, attachments: images });
  };

  removeMonitorFromAddMonitor = (id) => {
    let newusersnew = [...this.state.newMonitor];
    let newchecknew = newusersnew.filter((it) => it != id);
    this.setState({
      ...this.state,
      removeIdMonitoring: id,
      newMonitor: newchecknew,
      activeTabKey: "note",
    });
  };
  reasonAsking = (name, singleEdit, type, fieldType = null) => {
    const reasonChangeFiledFiltered = this.state[type];
    let showReasonFilter;
    if (fieldType && fieldType === "select") {
      showReasonFilter = reasonChangeFiledFiltered.filter(
        (item) => item.field === name,
      );
    } else {
      showReasonFilter = reasonChangeFiledFiltered.filter(
        (item) => item.show_reason && { ...item },
      );
    }
    let reasonasking = { ...this.state.reasonaskingdata };
    reasonasking[name] = singleEdit[name];
    this.setState((state) => {
      return {
        ...state,
        reasonModal: true,
        isStatusChanged: false,
        reason_pane_type: type,
        populateFormError: {},
        singleEditByReason: { ...singleEdit, name: name },
        reasonFilteredField: showReasonFilter,
        reasonaskingdata: reasonasking,
      };
    });
  };

  closeReasonModal = () => {
    this.setState(
      (state) => {
        return {
          ...state,
          reasonModal: false,
          pauseSelectStatus: "",
          reasonaskingdata: {},
        };
      },
      () => {
        this.removeAllEditInline(this.state.singleEditByReason["details_pane"]);
      },
    );
  };

  dependencyAsking = (
    name,
    singleEdit,
    type,
    item = null,
    attributeType = null,
    calculateEffort = null,
  ) => {
    let deps = item?.dependencies;
    if (typeof deps === "string") {
      try {
        deps = JSON.parse(deps);
      } catch (e) {
        deps = null;
      }
    }
    const defaultDependencies = {
      architecture_diagram: {
        can_empty: true,
      },
      impact_analysis: {
        can_empty: true,
      },
    };
    deps = deps && Object.keys(deps).length > 0 ? deps : defaultDependencies;

    const evalRows = {
      ...(this.state.rows || {}),
      ...(singleEdit || {}),
    };

    const visibleDeps = getVisibleDependencies(deps, evalRows, item);

    if (Object.keys(visibleDeps).length > 0) {
      this.setState({
        has_dependencies: true,
        dependencies: deps,
        dependencySelectStatus: item || {},
        isStatusDependency: false,
        pendingDependencyEdit: {
          name,
          singleEdit,
          type,
          item,
          attributeType,
          calculateEffort,
        },
        dependencyModalTitle: "Update required for the below fields",
      });
      return true;
    }
    return false;
  };

  closeDependenciesModal = () => {
    const paneType = this.state.pendingDependencyEdit?.type;
    this.setState(
      {
        has_dependencies: false,
        dependencies: {},
        dependencySelectStatus: {},
        isStatusDependency: false,
        pendingDependencyEdit: null,
      },
      () => {
        if (paneType) {
          this.removeAllEditInline(paneType);
        }
      },
    );
  };

  handleDependencyStatusSubmit = async (formData, naState) => {
    try {
      const item = this.state.dependencySelectStatus;

      let modalClosed = false;

      // ---------------------------------------------------------
      // 1. Prepare dependency field API calls
      // ---------------------------------------------------------
      const depKeys = Object.keys(formData || {});

      const dependencyPromises = depKeys.map((field) => {
        const val = naState?.[field] ? "" : formData[field];

        return this.dataSubmit({ [field]: val }).finally(() => {
          // Close modal only once - when first API completes
          if (!modalClosed) {
            modalClosed = true;
            this.closeDependenciesModal();
          }
        });
      });

      // ---------------------------------------------------------
      // 2. Status update
      // ---------------------------------------------------------
      let statusPromise = null;

      if (this.state.isStatusDependency || !this.state.pendingDependencyEdit) {
        if (!item) return;

        const statusFormData = {
          app_token: this.state.boarddata.app_token,
          user_uuid: this.state.boarddata.user_uuid,
          attribute_set_key: this.props.match.params.attribute_set_key,
          customer_tattle_uuid: +this.props.match.params.id,
          attribute_key: "status",
          status_id: item.id || item._id,
        };

        statusPromise = apiHandler("status", statusFormData).finally(() => {
          // Close modal if status API finishes first
          if (!modalClosed) {
            modalClosed = true;
            this.closeDependenciesModal();
          }
        });

        // -------------------------------------------------------
        // Run dependency updates + status update simultaneously
        // -------------------------------------------------------
        const results = await Promise.all([
          ...dependencyPromises,
          statusPromise,
        ]);

        // Status API result is the last item
        const rdata = results[results.length - 1];

        if (rdata && rdata.code === 200) {
          setTimeout(() => {
            this.setState({
              ...this.state,

              has_dependencies: false,
              dependencies: {},
              dependencySelectStatus: {},
              isStatusDependency: false,
              pendingDependencyEdit: null,

              status: rdata?.data?.workflow,

              currentSelectedStatusName: rdata?.data?.[item.id || item._id],

              selectStatus: {
                ...rdata?.data?.workflow?.find(
                  (wfItem) =>
                    wfItem.id === rdata?.data?.current_status ||
                    wfItem._id === rdata?.data?.current_status,
                ),
              },

              buttonDisabledStatus: false,

              rows: {
                ...this.state.rows,
                ...formData,

                has_sla: rdata?.data?.has_sla,
                sla_missed: rdata?.data?.sla_missed,

                sla_fields: rdata?.data?.sla_fields || [],

                sla_info: rdata?.data?.sla_info || [],

                sla_missed_list: rdata?.data?.sla_missed_list || [],

                active_sla_list: rdata?.data?.active_sla_list || [],

                next_response_timestamp: rdata?.data?.next_response_timestamp,
              },
            });
          });
        } else {
          this.closeDependenciesModal();
        }

        return;
      }

      // ---------------------------------------------------------
      // 3. Inline dependency edit
      // ---------------------------------------------------------
      const { singleEdit, attributeType, name, calculateEffort, type } =
        this.state.pendingDependencyEdit;

      let singleEditPromise = null;

      if (singleEdit) {
        singleEditPromise = this.dataSubmit(
          singleEdit,
          attributeType,
          name,
          null,
          calculateEffort,
        ).finally(() => {
          // Close modal if this API finishes first
          if (!modalClosed) {
            modalClosed = true;
            this.closeDependenciesModal();
          }
        });
      }

      // ---------------------------------------------------------
      // 4. Run dependency API + single edit API simultaneously
      // ---------------------------------------------------------
      const promises = [
        ...dependencyPromises,
        ...(singleEditPromise ? [singleEditPromise] : []),
      ];

      if (promises.length > 0) {
        await Promise.all(promises);
      }

      // ---------------------------------------------------------
      // 5. Remove inline edit
      // ---------------------------------------------------------
      if (type) {
        this.removeAllEditInline(type);
      }

      // ---------------------------------------------------------
      // 6. Update state
      // ---------------------------------------------------------
      this.setState({
        has_dependencies: false,
        dependencies: {},
        dependencySelectStatus: {},
        isStatusDependency: false,
        pendingDependencyEdit: null,

        rows: {
          ...this.state.rows,
          ...formData,
          ...(singleEdit || {}),
        },
      });
    } catch (err) {
      console.error("Error submitting dependency status:", err);

      this.closeDependenciesModal();
    }
  };

  getModalContent = () => {
    let extension_check = ["jpeg", "png", "jpg"];
    return (
      <>
        <form onSubmit={this.onSubmitAttachmentHandler}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="file-select">
                <div className="file-select-name" id="noFile2">
                  <div>
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.4966 2.21875C10.6066 2.25362 7.84482 3.41715 5.80115 5.46082C3.75748 7.50449 2.59395 10.2663 2.55908 13.1562C2.59395 16.0462 3.75748 18.808 5.80115 20.8517C7.84482 22.8953 10.6066 24.0589 13.4966 24.0938C16.3866 24.0589 19.1483 22.8953 21.192 20.8517C23.2357 18.808 24.3992 16.0462 24.4341 13.1562C24.3992 10.2663 23.2357 7.50449 21.192 5.46082C19.1483 3.41715 16.3866 2.25362 13.4966 2.21875ZM19.7466 13.9375H14.2778V19.4062H12.7153V13.9375H7.24658V12.375H12.7153V6.90625H14.2778V12.375H19.7466V13.9375Z"
                        fill="#717171"
                      ></path>
                    </svg>
                  </div>
                  Add File
                </div>
                <input
                  type="file"
                  name="chooseFile"
                  id=""
                  title=""
                  multiple
                  onChange={this.attachmentUploadHandler}
                />
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="custom_image">
                {this.state.attachments.length > 0 && (
                  <div className="afterupload-image">
                    {this.state.attachments.map((file, index) => {
                      const imgg = URL.createObjectURL(file);
                      return (
                        <div className="img-box">
                          <Error>
                            <ImagePreview
                              headImage={imgg}
                              ext={file.name.split(".").pop()}
                              imgLength={this.state.attachments}
                              width="128px"
                              height="58px"
                            />
                          </Error>

                          <figure>
                            {file?.name?.slice(0, 6) +
                              "." +
                              file?.name.split(".").pop()}
                          </figure>
                          <div
                            className="delete"
                            onClick={() =>
                              this.removeImageHandler(index, file.name)
                            }
                          >
                            <svg
                              width="11"
                              height="10"
                              viewBox="0 0 11 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <title>Remove</title>
                              <path
                                d="M8.21973 2.5L3.21973 7.5"
                                stroke="#737373"
                                stroke-width="1.33"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                              <path
                                d="M3.21973 2.5L8.21973 7.5"
                                stroke="#737373"
                                stroke-width="1.33"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {this.arrayNew.length > 0 && (
                  <div className="image_failed_list">
                    <ul>
                      {this.arrayNew.map((item, index) => (
                        <li key={index}>
                          <Alert variant="danger">
                            {item.name} : {item.message}
                          </Alert>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="cancl-cls"
              data-bs-dismiss="modal"
              onClick={this.hideUiModal}
            >
              Cancel
            </button>
            <button type="submit" className="submit-cls">
              {this.state.mainImageUpload ? "Uploading..." : "Submit"}
            </button>
          </div>
        </form>
      </>
    );
  };
  getError = (err) => {
    if (err) {
      setTimeout(() => {
        this.setState({ ...this.state, validDescription: err });
      });
    } else {
      setTimeout(() => {
        this.setState({ ...this.state, validDescription: "" });
      });
    }
  };

  getErrorLongText = (err) => {
    if (err) {
      this.setState({ ...this.state, validDescriptionLongText: err });
    } else {
      this.setState({ ...this.state, validDescriptionLongText: "" });
    }
  };
  // reason

  reasonChangeHandler = (event) => {
    this.setState((state) => {
      return {
        ...state,
        reasonNote: event.target.value,
      };
    });
  };

  getAskReasonApiCall = (api) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${api}`);
        const rdata = await response.json();
        if (rdata.length > 0) {
          const responseApi = rdata.map((item) => ({
            label: item.value,
            value: item.id,
          }));
          this.setState({ ...this.state, apiDataResponse: responseApi });
          resolve(responseApi);
        }
      } catch (err) {
        reject(err);
        console.log(err);
      }
    });
  };
  formatContent = (inputString) => {
    const linkRegex = /<a[^>]*>.*?<\/a>|((http:\/\/|https:\/\/)[^\s]+)/gi;

    // return inputString.replace(linkRegex, (match, group1) => {
    //   if (group1) {
    //     return `<a href="${group1
    //       .replace(/<p>/g, "")
    //       .replace(/<\/p>/g, "")}" target="_blank">${group1}</a>`;
    //   } else {
    //     return match;
    //   }
    // });

    return inputString;
  };
  populateForm = (field, data = []) => {
    const isescalation = data.hasOwnProperty("escalation_level");
    let reasonData = { ...this.state.reasonaskingdata };
    let form;
    if (field.length > 0) {
      form = field.map((item, index) => {
        if (item.attribute_type === "assign_to") {
          const { options: assignTo } = item;

          const options = Object.keys(assignTo).map((key) => ({
            label: assignTo[key].name,
            value: key,
          }));
          const values = data[item.field]
            ? options.filter((itm) => itm.value === data[item.field])
            : options.filter(
                (itm) => itm.value === this.state.rows[item.field],
              );
          if (!data[item.field]) {
            reasonData = {
              ...reasonData,
              [item.field]: this.state.rows[item.field],
            };
          }
          return (
            <>
              <div className="form-group" key={index}>
                <label>{item.headerName}</label>
                {item.is_required && <sup className="form-mandatory">*</sup>}
                <ReactSelect
                  options={options}
                  value={values}
                  onChange={(evt) => this.reasonValueChange(evt, item.field)}
                />
                <div className="error">
                  {this.state.populateFormError[item.field]}
                </div>
              </div>
            </>
          );
        }
        if (item.attribute_type === "reporter") {
          const { options: assignTo } = item;

          const options = Object.keys(assignTo).map((key) => ({
            label: assignTo[key].name,
            value: key,
          }));

          const values = data[item.field]
            ? options.filter((itm) => itm.value === data[item.field])
            : options.filter(
                (itm) => itm.value === this.state.rows[item.field],
              );
          if (!data[item.field]) {
            reasonData = {
              ...reasonData,
              [item.field]: this.state.rows[item.field],
            };
          }
          return (
            <>
              <div className="form-group" key={index}>
                <label>{item.headerName}</label>
                {item.is_required && <sup className="form-mandatory">*</sup>}
                <ReactSelect
                  options={options}
                  value={values}
                  onChange={(evt) => this.reasonValueChange(evt, item.field)}
                />
                <div className="error">
                  {this.state.populateFormError[item.field]}
                </div>
              </div>
            </>
          );
        }
        if (item.attribute_type === "category") {
          const { options: selectOptions } = item;

          const options = selectOptions.map((item) => ({
            label: item.name,
            value: item.id || item._id,
          }));

          const values = data[item.field]
            ? options.filter((itm) => itm.value === data[item.field])
            : options.filter(
                (itm) => itm.value === this.state.rows[item.field],
              );
          if (!data[item.field]) {
            reasonData = {
              ...reasonData,
              [item.field]: this.state.rows[item.field],
            };
          }

          return (
            <>
              <div className="form-group" key={index}>
                <label>{item.headerName}</label>
                {item.is_required && <sup className="form-mandatory">*</sup>}
                <ReactSelect
                  options={options}
                  value={values}
                  onChange={(evt) => this.reasonValueChange(evt, item.field)}
                />
                <div className="error">
                  {this.state.populateFormError[item.field]}
                </div>
              </div>
            </>
          );
        }
        if (item.attribute_type === "select") {
          const { options: selectOptions } = item;

          const options = selectOptions.map((item) => ({
            label: item.option_name,
            value: item.id || item._id,
          }));

          const value = options.filter((key) => key.value == data[item.field]);
          const values = data[item.field]
            ? options.filter((itm) => itm.value === data[item.field])
            : options.filter(
                (itm) => itm.value === this.state.rows[item.field],
              );
          if (!data[item.field]) {
            reasonData = {
              ...reasonData,
              [item.field]: this.state.rows[item.field],
            };
          }
          return (
            <>
              <div className="form-group" key={index}>
                <label>{item.headerName}</label>
                {item.is_required && <sup className="form-mandatory">*</sup>}
                <ReactSelect
                  isDisabled={isescalation}
                  options={options}
                  value={values}
                  menuPlacement="auto"
                  onChange={(evt) => this.reasonValueChange(evt, item.field)}
                />
                <div className="error">
                  {this.state.populateFormError[item.field]}
                </div>
              </div>
            </>
          );
        }
        if (item.attribute_type === "api") {
          const values = data[item.field]
            ? this.state.apiDataResponse.filter(
                (itm) => itm.value === data[item.field],
              )
            : this.state.apiDataResponse.filter(
                (itm) => itm.value === this.state.rows[item.field],
              );
          if (!data[item.field]) {
            reasonData = {
              ...reasonData,
              [item.field]: this.state.rows[item.field],
            };
          }
          return (
            <>
              <div className="form-group" key={index}>
                <label>{item.headerName}</label>
                {item.is_required && <sup className="form-mandatory">*</sup>}
                <AsyncReactSelect
                  cacheOptions
                  defaultOptions
                  value={values}
                  loadOptions={() => this.getAskReasonApiCall(item.api_url)}
                  onChange={(evt) => this.reasonValueChange(evt, item.field)}
                />
                <div className="error">
                  {this.state.populateFormError[item.field]}
                </div>
              </div>
            </>
          );
        }
        if (item.attribute_type === "date") {
          const values = data[item.field]
            ? data[item.field]
            : this.state.rows[item.field];
          if (!data[item.field]) {
            reasonData = {
              ...reasonData,
              [item.field]: this.state.rows[item.field],
            };
          }
          return (
            <>
              <div className="form-group" key={index}>
                <label>{item.headerName}</label>
                {item.is_required && <sup className="form-mandatory">*</sup>}
                <input
                  type="date"
                  className="form-control"
                  value={values}
                  onChange={(evt) => this.reasonValueChange(evt, item.field)}
                />
                <div className="error">
                  {this.state.populateFormError[item.field]}
                </div>
              </div>
            </>
          );
        }
        if (item.attribute_type === "start_date") {
          let currentDate = new Date();
          let pastDate = !isNaN(Date.parse(this.state.rows[item.field]))
            ? new Date(this.state.rows[item.field])
            : currentDate.setDate(currentDate.getDate() - 30);
          const values = data.hasOwnProperty(item.field)
            ? data[item.field]
            : this.state.rows[item.field];
          if (!data[item.field]) {
            reasonData = {
              ...reasonData,
              [item.field]: this.state.rows[item.field],
            };
          }
          let crossDate;
          if (item.field === "start_date" && data["start_date"]) {
            pastDate = new Date(data["start_date"]).setDate(
              new Date(data["start_date"]).getDate() - 30,
            );
            crossDate = new Date(
              Math.max(
                new Date(this.state.rows?.["end_date"]),
                new Date(this.state.rows?.["go_live_date"]),
              ),
            ).setDate(
              new Date(
                Math.max(
                  new Date(this.state.rows?.["end_date"]),
                  new Date(this.state.rows?.["go_live_date"]),
                ),
              ).getDate(),
            );
          }
          if (
            (item.field === "start_date" && this.state.rows["go_live_date"]) ||
            this.state.rows["end_date"]
          ) {
            pastDate = new Date(this.state.rows["go_live_date"]).setDate(
              new Date(this.state.rows["go_live_date"]).getDate() - 30,
            );
            crossDate = new Date(this.state.rows["go_live_date"]).setDate(
              new Date(this.state.rows["go_live_date"]).getDate(),
            );
          }
          if (
            (item.field === "start_date" && data["end_date"]) ||
            this.state.rows["end_date"]
          ) {
            pastDate = new Date(
              data["end_date"] || this.state.rows["end_date"],
            ).setDate(
              new Date(
                data["end_date"] || this.state.rows["end_date"],
              ).getDate() - 30,
            );
            crossDate = new Date(
              data["end_date"] || this.state.rows["end_date"],
            ).setDate(
              new Date(
                data["end_date"] || this.state.rows["end_date"],
              ).getDate(),
            );
          }

          if (
            item.field === "qa_start_date" &&
            this.state.rows["go_live_date"]
          ) {
            pastDate = new Date(this.state.rows["go_live_date"]).setDate(
              new Date(this.state.rows["go_live_date"]).getDate() - 30,
            );
            crossDate = new Date(
              this.state.rows["go_live_date"] ||
                this.state.rows["go_live_date"],
            ).setDate(new Date(this.state.rows["go_live_date"]).getDate());
          }

          if (
            item.field === "qa_start_date" &&
            this.state.rows["qa_end_date"]
          ) {
            pastDate = new Date(this.state.rows["qa_end_date"]).setDate(
              new Date(this.state.rows["qa_end_date"]).getDate() - 30,
            );
            crossDate = new Date(
              this.state.rows["qa_end_date"] || this.state.rows["go_live_date"],
            ).setDate(new Date(this.state.rows["qa_end_date"]).getDate());
          }
          if (item.field === "qa_start_date" && data["qa_end_date"]) {
            pastDate = new Date(data["qa_end_date"]).setDate(
              new Date(data["qa_end_date"]).getDate() - 30,
            );
            crossDate = new Date(
              data["qa_end_date"] || this.state.rows["go_live_date"],
            ).setDate(new Date(data["qa_end_date"]).getDate());
          }
          if (
            item.field === "qa_start_date" &&
            this.state.rows["go_live_date"] &&
            this.state.rows["qa_end_date"]
          ) {
            pastDate = new Date(
              data["qa_end_date"] ||
                this.state.rows["qa_end_date"] ||
                this.state.rows["go_live_date"],
            ).setDate(
              new Date(
                data["qa_end_date"] ||
                  this.state.rows["qa_end_date"] ||
                  this.state.rows["go_live_date"],
              ).getDate() - 30,
            );
            crossDate = new Date(
              data["qa_end_date"] ||
                this.state.rows["qa_end_date"] ||
                this.state.rows["go_live_date"],
            ).setDate(
              new Date(
                data["qa_end_date"] ||
                  this.state.rows["qa_end_date"] ||
                  this.state.rows["go_live_date"],
              ).getDate(),
            );
          }
          return (
            <>
              <div className="form-group" key={index}>
                <label>{item.headerName}</label>
                <sup className="form-mandatory">*</sup>
                <ReactDatePicker
                  selected={values ? new Date(values) : null}
                  dateFormat="dd-MM-yyyy"
                  onChange={(evt) =>
                    this.reasonDatePickerChange(evt, item.field)
                  }
                  isClearable
                  className="rasta-stripes"
                  // minDate={pastDate}
                  // maxDate={crossDate}
                />
                {/* <input
                                  type="date"
                  className="form-control"
                  value={values}
                  onChange={(evt) => this.reasonValueChange(evt, item.field)}
                    /> */}
                <div className="error">
                  {this.state.populateFormError[item.field]}
                </div>
              </div>
            </>
          );
        }
        if (item.attribute_type === "end_date") {
          const values = data.hasOwnProperty(item.field)
            ? data[item.field]
            : this.state.rows[item.field];
          if (!data[item.field]) {
            reasonData = {
              ...reasonData,
              [item.field]: this.state.rows[item.field],
            };
          }

          let currentDate = new Date();
          let pastDate = currentDate.setDate(currentDate.getDate() - 30);
          let crossDate = currentDate.setDate(currentDate.getDate() + 30);
          if (item.field === "qa_end_date" && data?.["qa_start_date"]) {
            pastDate = new Date(data["qa_start_date"]).setDate(
              new Date(data["qa_start_date"]).getDate(),
            );

            crossDate = new Date(
              data?.["qa_start_date"] || this.state.rows["qa_start_date"],
            ).setDate(
              new Date(
                data?.["qa_start_date"] || this.state.rows["qa_start_date"],
              ).getDate() + 30,
            );
          }

          if (item.field === "qa_end_date" && data?.["qa_end_date"]) {
            pastDate = new Date(data["qa_end_date"]).setDate(
              new Date(data["qa_end_date"]).getDate(),
            );

            crossDate = new Date(
              data?.["qa_end_date"] || this.state.rows["qa_end_date"],
            ).setDate(
              new Date(
                data?.["qa_end_date"] || this.state.rows["qa_end_date"],
              ).getDate() + 30,
            );
          }

          if (
            item.field === "qa_end_date" &&
            !data?.["qa_end_date"] &&
            (this.state.rows["qa_start_date"] || data["qa_start_date"])
          ) {
            pastDate = new Date(
              this.state.rows["qa_start_date"] || data["qa_start_date"],
            ).setDate(
              new Date(
                this.state.rows["qa_start_date"] || data["qa_start_date"],
              ).getDate(),
            );

            crossDate = new Date(
              this.state.rows["qa_start_date"] || data["qa_start_date"],
            ).setDate(
              new Date(
                this.state.rows["qa_start_date"] || data["qa_start_date"],
              ).getDate() + 30,
            );
          }

          if (
            item.field === "qa_end_date" &&
            this.state.rows?.["qa_start_date"] &&
            this.state.rows?.["go_live_date"]
          ) {
            pastDate = new Date(this.state.rows?.["qa_start_date"]).setDate(
              new Date(this.state.rows?.["qa_start_date"]).getDate(),
            );

            crossDate = new Date(this.state.rows["go_live_date"]).setDate(
              new Date(this.state.rows["go_live_date"]).getDate(),
            );
          }

          if (
            item.field === "qa_end_date" &&
            data?.["qa_start_date"] &&
            this.state.rows?.["go_live_date"]
          ) {
            pastDate = new Date(data?.["qa_start_date"]).setDate(
              new Date(data?.["qa_start_date"]).getDate(),
            );

            crossDate = new Date(this.state.rows["go_live_date"]).setDate(
              new Date(this.state.rows["go_live_date"]).getDate(),
            );
          }

          if (item.field === "end_date" && data["start_date"]) {
            pastDate = new Date(data["start_date"]).setDate(
              new Date(data["start_date"]).getDate(),
            );

            crossDate = new Date(data["start_date"]).setDate(
              new Date(data["start_date"]).getDate() + 30,
            );
          }
          if (item.field === "end_date" && this.state.rows?.["start_date"]) {
            pastDate = new Date(this.state.rows["start_date"]).setDate(
              new Date(this.state.rows["start_date"]).getDate(),
            );

            crossDate = new Date(this.state.rows["start_date"]).setDate(
              new Date(this.state.rows["start_date"]).getDate() + 30,
            );
          }
          if (
            item.field === "end_date" &&
            !data?.["end_date"] &&
            (this.state.rows["start_date"] || data["start_date"])
          ) {
            pastDate = new Date(
              this.state.rows["start_date"] || data["start_date"],
            ).setDate(
              new Date(
                this.state.rows["start_date"] || data["start_date"],
              ).getDate(),
            );

            crossDate = new Date(
              this.state.rows["start_date"] || data["start_date"],
            ).setDate(
              new Date(
                this.state.rows["start_date"] || data["start_date"],
              ).getDate() + 30,
            );
          }
          if (
            item.field === "end_date" &&
            this.state.rows["start_date"] &&
            this.state.rows["go_live_date"]
          ) {
            pastDate = new Date(
              data["start_date"] || this.state.rows["start_date"],
            ).setDate(
              new Date(
                data["start_date"] || this.state.rows["start_date"],
              ).getDate(),
            );

            crossDate = new Date(
              new Date(this.state.rows["go_live_date"]),
            ).setDate(new Date(this.state.rows["go_live_date"]).getDate());
          }
          return (
            <>
              <div className="form-group" key={index}>
                <label>{item.headerName}</label>
                <sup className="form-mandatory">*</sup>
                <ReactDatePicker
                  selected={values ? new Date(values) : null}
                  dateFormat="dd-MM-yyyy"
                  onChange={(evt) =>
                    this.reasonDatePickerChange(evt, item.field)
                  }
                  isClearable
                  className="rasta-stripes"
                  // minDate={pastDate}
                  // maxDate={crossDate}
                />
                {/* <input
                  type="date"
                  className="form-control"
                  value={values}
                  onChange={(evt) => this.reasonValueChange(evt, item.field)}
               /> */}
                <div className="error">
                  {this.state.populateFormError[item.field]}
                </div>
              </div>
            </>
          );
        }
        if (item.attribute_type === "go_live_date") {
          const values = data.hasOwnProperty(item.field)
            ? data[item.field]
            : this.state.rows["go_live_date"];
          if (!data[item.field]) {
            reasonData = {
              ...reasonData,
              [item.field]: this.state.rows[item.field],
            };
          }

          let pastDate = new Date();
          let crossDate = new Date();

          pastDate = new Date().setDate(new Date().getDate() - 30);
          crossDate = new Date().setDate(new Date().getDate() + 30);
          const { rows } = this.state;
          if (rows.end_date) {
            pastDate = new Date(new Date(rows.end_date)).setDate(
              new Date(new Date(rows.end_date)).getDate(),
            );
          }
          if (rows.start_date && rows.end_date) {
            pastDate = new Date(
              Math.max(new Date(rows.start_date), new Date(rows.end_date)),
            ).setDate(
              new Date(
                Math.max(new Date(rows.start_date), new Date(rows.end_date)),
              ).getDate(),
            );
          }
          if (rows.qa_start_date) {
            pastDate = new Date(new Date(rows.qa_start_date)).setDate(
              new Date(rows.qa_start_date).getDate(),
            );
          }
          if (rows.qa_end_date) {
            pastDate = new Date(new Date(rows.qa_start_date)).setDate(
              new Date(rows.qa_start_date).getDate(),
            );
          }
          if (rows.qa_start_date && rows.qa_end_date) {
            pastDate = new Date(
              Math.max(
                new Date(rows.qa_start_date),
                new Date(rows.qa_end_date),
              ),
            ).setDate(
              new Date(
                Math.max(
                  new Date(rows.qa_start_date),
                  new Date(rows.qa_end_date),
                ),
              ).getDate(),
            );
          }
          if (rows.qa_start_date && rows.qa_end_date && rows.start_date) {
            pastDate = new Date(
              Math.max(
                new Date(rows.qa_start_date),
                new Date(rows.qa_end_date),
                new Date(rows.start_date),
              ),
            ).setDate(
              new Date(
                Math.max(
                  new Date(rows.qa_start_date),
                  new Date(rows.qa_end_date),
                  new Date(rows.start_date),
                ),
              ).getDate(),
            );
          }
          if (
            rows.qa_start_date &&
            rows.qa_end_date &&
            rows.start_date &&
            rows.end_date
          ) {
            pastDate = new Date(
              Math.max(
                new Date(rows.qa_start_date),
                new Date(rows.qa_end_date),
                new Date(rows.start_date),
                new Date(rows.end_date),
              ),
            ).setDate(
              new Date(
                Math.max(
                  new Date(rows.qa_start_date),
                  new Date(rows.qa_end_date),
                  new Date(rows.start_date),
                  new Date(rows.end_date),
                ),
              ).getDate(),
            );
          }

          return (
            <>
              <div className="form-group" key={index}>
                <label>{item.headerName}</label>
                {/* <sup className="form-mandatory">*</sup> */}
                {/* <input
                  type="date"
                  className="form-control"
                  value={values}
                  onChange={(evt) => this.reasonValueChange(evt, item.field)}
                       /> */}
                <ReactDatePicker
                  selected={values ? new Date(values) : null}
                  dateFormat="dd-MM-yyyy"
                  onChange={(evt) =>
                    this.reasonDatePickerChange(evt, item.field)
                  }
                  isClearable
                  className="rasta-stripes"
                  // minDate={pastDate}
                  // maxDate={crossDate}
                />
                <div className="error">
                  {this.state.populateFormError[item.field]}
                </div>
              </div>
            </>
          );
        }
        if (item.attribute_type === "text") {
          if (!data[item.field]) {
            reasonData = {
              ...reasonData,
              [item.field]: this.state.rows[item.field],
            };
          }
          return (
            <>
              <div className="form-group" key={index}>
                <label>{item.headerName}</label>
                {item.is_required && <sup className="form-mandatory">*</sup>}
                <input
                  type="text"
                  className="form-control"
                  value={data[item.field]}
                  onChange={(evt) => this.reasonValueChange(evt, item.field)}
                />
                <div className="error">
                  {this.state.populateFormError[item.field]}
                </div>
              </div>
            </>
          );
        }
      });
    }
    this.createFormData = reasonData;
    return form;
  };
  checkIsValid = (rest) => {
    let isValid = true;
    let populateformerror = { ...this.state.populateFormError };

    let newformerror = [...this.state.reasonFilteredField].filter(
      (item) => item.attribute_type !== "go_live_date",
    );

    newformerror.some((item) => {
      if (
        rest[item.field] == undefined ||
        rest[item.field] == null ||
        rest[item.field] == ""
      ) {
        populateformerror[item.field] = `${item.field
          .split("_")
          .map((it, index) => (it === "qa" && index === 0 ? "QA" : it))
          .join(" ")} is required`;
        isValid = false;
      }
    });
    this.setState({ ...this.state, populateFormError: populateformerror });
    if (!isValid) {
      this.setState((state) => {
        return {
          ...state,
          buttonDisabled: true,
        };
      });
    } else {
      this.setState((state) => {
        return {
          ...state,
          buttonDisabled: false,
        };
      });
    }
    return isValid;
  };
  onReasonSubmitHandler = async (event) => {
    event.preventDefault();
    setTimeout(() => {
      this.setState(
        (state) => {
          return {
            ...state,
            activeTabKey: "note",
          };
        },
        () => {},
      );
    });
    if (this.state.isStatusChanged && this.state.reasonaskingdata["note"]) {
      this.setState((state) => {
        return {
          ...state,
          isAddReason: true,
        };
      });
      const statusdata = {
        app_token: this.getCommonData().app_token,
        user_uuid: this.getCommonData().user_uuid,
        customer_tattle_uuid: +this.props.match.params.id,
        attribute_set_key: this.props.match.params.attribute_set_key,
        event_id: 43,
        note_content: this.state.reasonaskingdata["note"],
        attributes: {
          [this.state.selectStatus.attribute_key]:
            this.state.pauseSelectStatus.id || this.state.pauseSelectStatus._id,
        },
      };
      const responsedata = await fetch(`${this.state.apiUrl}add-reason`, {
        method: "POST",
        body: JSON.stringify(statusdata),
      });
      const rdata = await responsedata.json();
      if (rdata.code === 200) {
        setTimeout(() => {
          this.setState(
            (state) => {
              return {
                ...state,
                reasonModal: false,
                isStatusChanged: false,
                isAddReason: false,
                rows: {
                  ...state.rows,
                  status:
                    state.pauseSelectStatus.id || state.pauseSelectStatus._id,
                },
                selectStatus: {
                  ...state.selectStatus,
                  ...state.pauseSelectStatus,
                },
                status: [{ ...state.status, options: rdata?.workflow }],
                reasonaskingdata: { ["note"]: "" },
                // createBoard: {
                //   ...state.createBoard,
                //   board: true,
                //   message: rdata.message,
                //   title: rdata.status,
                //   code: "status-change",
                // },
              };
            },
            async () => {
              // this.props.updateStatusRow(
              //   this.state.selectStatus._id,
              //   rdata?.workflow
              // );
              const rnote = await this.props.getNote(
                {
                  app_token: this.state.boarddata.app_token,
                  attribute_set_key: this.props.match.params.attribute_set_key,
                  customer_tattle_uuid: Number(this.props.match.params.id),
                  attribute_set_type: this.state.boarddata.attribute_set_type,
                  is_external: this.state.is_external,
                },
                "status",
              );
              if (rnote.code == 200) {
                this.setState((state) => {
                  return {
                    ...state,
                    notes: rnote?.data.map((item) =>
                      item.hasOwnProperty("attachment")
                        ? {
                            ...item,
                            attachment: this.isValidJSON(item.attachment)
                              ? JSON.parse(item.attachment)
                              : item.attachment,
                          }
                        : { ...item },
                    ),
                  };
                });
              }
              const rhistory = await this.props.getBoardHistory(
                {
                  app_token: this.state.boarddata.app_token,
                  attribute_set_key: this.props.match.params.attribute_set_key,
                  customer_tattle_uuid: Number(this.props.match.params.id),
                  attribute_set_type: this.state.boarddata.attribute_set_type,
                },
                "status",
              );

              if (rhistory.code == 200) {
                this.setState((state) => {
                  return {
                    ...state,
                    history: rhistory.data,
                    history_attributes: rhistory.attributes,
                  };
                });
              }
            },
          );
        }, 500);
      }
      return;
    }
    const rowsdata = { ...this.state.rows, ...this.state.reasonaskingdata };

    const { note, ...rest } = {
      ...this.createFormData,
      ...this.state.reasonaskingdata,
    };
    let newdatareson = {
      app_token: this.getCommonData().app_token,
      user_uuid: this.getCommonData().user_uuid,
      customer_tattle_uuid: +this.props.match.params.id,
      attribute_set_key: this.props.match.params.attribute_set_key,
      note_content: this.state.reasonaskingdata["note"],
      attributes: { ...rest },
    };
    if (
      this.state.reason_pane_type === "planning_date" ||
      this.state.reason_pane_type === "qa_project_plan" ||
      this.state.reason_pane_type === "scrum_project_plan"
    ) {
      newdatareson["event_id"] = 42;
    }
    if (
      this.checkIsValid(rest) &&
      this.state.reasonaskingdata["note"] &&
      !this.state.isAddReason
    ) {
      this.setState((state) => {
        return {
          ...state,
          isAddReason: true,
        };
      });
      const responsedata = await fetch(`${this.state.apiUrl}add-reason`, {
        method: "POST",
        body: JSON.stringify(newdatareson),
      });

      const rdata = await responsedata.json();

      if (rdata.code === 200) {
        this.removeAllEditInline(this.state.singleEditByReason.details_pane);
        this.setState(
          (state) => {
            return {
              ...state,
              reasonModal: false,
              rows: rowsdata,
              isAddReason: false,
              reasonaskingdata: { ["note"]: "" },
              // createBoard: {
              //   ...state.createBoard,
              //   board: true,
              //   message: rdata.message,
              //   title: rdata.status,
              //   code: "status-change",
              //   bg: "primary",
              // },
            };
          },
          () => {
            setTimeout(async () => {
              const newdata = this.props.addReasonRowUpdate(rest, "status");
              if (newdata && Object.keys(newdata).length) {
                this.setState((state) => {
                  return {
                    ...state,
                    rows: {
                      ...state.rows,
                      ...newdata,
                    },
                  };
                });
              }

              const rnote = await this.props.getNote(
                {
                  app_token: this.state.boarddata.app_token,
                  attribute_set_key: this.props.match.params.attribute_set_key,
                  customer_tattle_uuid: Number(this.props.match.params.id),
                  attribute_set_type: this.state.boarddata.attribute_set_type,
                  is_external: this.state.is_external,
                },
                "status",
              );
              if (rnote.code == 200) {
                this.setState((state) => {
                  return {
                    ...state,
                    notes: rnote?.data,
                  };
                });
              }
              // const rhistory = await this.props.getBoardHistory(
              //   {
              //     app_token: this.state.boarddata.app_token,
              //     attribute_set_key: this.props.match.params.attribute_set_key,
              //     customer_tattle_uuid: Number(this.props.match.params.id),
              //     attribute_set_type: this.state.boarddata.attribute_set_type,
              //   },
              //   "status"
              // );

              // if (rhistory.code == 200) {
              //   this.setState((state) => {
              //     return {
              //       ...state,
              //       history: rhistory.data,
              //       history_attributes: rhistory.attributes,
              //     };
              //   });
              // }
            }, 1000);
          },
        );
      } else {
        this.setState((state) => {
          return {
            ...state,
            createBoard: {
              ...state.createBoard,
              board: true,
              message: rdata.message,
              title: rdata.status,
              bg: "danger",
            },
          };
        });
      }
    }
  };
  allowEditNote = (item) => {
    return (
      item.user_uuid == this.getCommonData().user_uuid && (
        <div
          class="right-svg"
          data-bs-toggle="modal"
          data-bs-target="#editNoteEdit"
          onClick={() => this.handleEditModal(item.id || item._id)}
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1107_16519)">
              <path
                d="M12.2861 2.46439C12.4612 2.2893 12.6691 2.1504 12.8979 2.05564C13.1266 1.96088 13.3718 1.91211 13.6195 1.91211C13.8671 1.91211 14.1123 1.96088 14.3411 2.05564C14.5698 2.1504 14.7777 2.2893 14.9528 2.46439C15.1279 2.63949 15.2668 2.84736 15.3616 3.07613C15.4563 3.30491 15.5051 3.5501 15.5051 3.79773C15.5051 4.04535 15.4563 4.29055 15.3616 4.51932C15.2668 4.7481 15.1279 4.95597 14.9528 5.13106L5.9528 14.1311L2.28613 15.1311L3.28613 11.4644L12.2861 2.46439Z"
                stroke="#334253"
                stroke-width="1.33"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </g>
            <defs>
              <clipPath id="clip0_1107_16519">
                <rect
                  width="16"
                  height="16"
                  fill="white"
                  transform="translate(0.953125 0.464355)"
                ></rect>
              </clipPath>
            </defs>
          </svg>
        </div>
      )
    );
  };
  getReasonData = (json, data) => {
    let reasonaskingdata = {
      ...this.state.reasonaskingdata,
      ...this.createFormData,
    };
    reasonaskingdata["note"] = data;
    this.setState((state) => {
      return {
        ...state,
        reasonaskingdata,
      };
    });
  };
  getNoteAlignment = (alignmentType, item, index) => {
    return (
      <div
        className={`row ${alignmentType}`}
        key={index}
        id={`note${item?.custom_note_uuid || item?.id || item?._id}`}
      >
        <div
          class={
            (this.state.is_external && item.is_external == 0) ||
            (this.state.is_external === 0 && item.is_external === 1)
              ? "col-lg-11"
              : "col-lg-12"
          }
        >
          <div
            class={
              item.note_type === "internal" ||
              item.note_type === "internal_email"
                ? "self-singlebox"
                : `self-singlebox border-${item.note_type}`
            }
          >
            <div className="d-flex justify-content-between align-items-center">
              {this.getNoteAndImage(item)}
              {(item.note_type === "internal" ||
                item.note_type === "internal_email") &&
                !item.hasOwnProperty("reason") &&
                this.allowEditNote(item)}
            </div>
            {item.note_type === "internal" ||
            item.note_type === "internal_email" ? (
              <div className="reasonsec">
                {item?.hasOwnProperty("reason") &&
                  Object.keys(item.reason).length > 0 &&
                  Object.keys(item.reason).map((nitem) => {
                    return (
                      <li>
                        <strong>{nitem} </strong>:{" "}
                        {nitem == "SLA Missed" ? "No" : item.reason[nitem]}
                      </li>
                    );
                  })}
              </div>
            ) : (
              ""
            )}
            {item.note_type === "internal" ||
            item.note_type === "internal_email" ? (
              <GmailReplyCollapse
                content={this.formatContent(item?.note_content)}
                className="note-text"
              />
            ) : (
              <GmailReplyCollapse
                content={item?.note_content}
                className="note-text"
              />
            )}
            {this.getAttachmentList(item)}
          </div>
        </div>
      </div>
    );
  };

  /* getNoteBody_bc = (item, index) => {
    if (item.note_type === "internal") {
      return (
        <div
          className="row justify-content-start"
          key={index}
          id={`note${item?.custom_note_uuid || item?._id}`}
        >
          <div class="col-lg-12">
            <div class="self-singlebox">
              <div className="d-flex justify-content-between align-items-center">
                {this.getNoteAndImage(item)}
                {!item.hasOwnProperty("reason") && this.allowEditNote(item)}
              </div>
              <div className="reasonsec">
                {item?.hasOwnProperty("reason") &&
                  Object.keys(item.reason).length > 0 &&
                  Object.keys(item.reason).map((nitem) => {
                    return (
                      <li>
                        <strong>{nitem} </strong>: {(nitem == "SLA Missed") ? "No" : item.reason[nitem]}
                      </li>
                    );
                  })}
              </div>
              <div
                class="note-text"
                dangerouslySetInnerHTML={{
                  __html: this.formatContent(item?.note_content),
                }}
              ></div>
              {this.getAttachmentList(item)}
            </div>
          </div>
        </div>
      );
    }

    if (item.note_type === "internal_email") {
      return (
        <div
          className="row justify-content-start"
          key={index}
          id={`note${item?.custom_note_uuid || item?._id}`}
        >
          <div class="col-lg-12">
            <div class="self-singlebox">
              <div className="d-flex justify-content-between align-items-center">
                {this.getNoteAndImage(item, item.user_details)}
                {!item.hasOwnProperty("reason") && this.allowEditNote(item)}
              </div>
              <div className="reasonsec">
                {item?.hasOwnProperty("reason") &&
                  Object.keys(item.reason).length > 0 &&
                  Object.keys(item.reason).map((nitem) => {
                    return (
                      <li>
                        <strong>{nitem} </strong>: {item.reason[nitem]}
                      </li>
                    );
                  })}
              </div>
              <div
                class="note-text"
                dangerouslySetInnerHTML={{
                  __html: this.formatContent(item?.note_content),
                }}
              ></div>
              {this.getAttachmentList(item)}
            </div>
          </div>
        </div>
      );
    }

    if (item.note_type === "external") {
      return (
        <div
          class="row justify-content-start"
          key={index}
          id={`note${item?.custom_note_uuid || item?._id}`}
        >
          <div class="col-lg-12">
            <div class="self-singlebox border-external">
              <div class="topPart d-flex justify-content-start align-items-center">
                {this.getNoteAndImage(item)}
              </div>
              <div
                class="note-text"
                dangerouslySetInnerHTML={{
                  __html: item?.note_content,
                }}
              ></div>
              {this.getAttachmentList(item)}
            </div>
          </div>
        </div>
      );
    }
    if (item.note_type === "customer") {
      return (
        <div
          className="row justify-content-end"
          key={index}
          id={`note${item?.custom_note_uuid || item?._id}`}
        >
          <div className="col-lg-11">
            <div className="other-singlebox">
              <div className="topPart d-flex justify-content-start align-items-center">
                <div className="left-side firstLetter">
                  <img
                    src={`${item?.customer_details?.profile_image || Frame}`}
                  />
                </div>
                <div className="right-side">
                  <div className="name">
                    {item.customer_details?.profile_url ? (
                      <a
                        target={"_blank"}
                        href={item?.customer_details?.profile_url}
                        className="checkUserNameNote"
                      >
                        {" "}
                        {item?.customer_details?.name}
                      </a>
                    ) : (
                      item?.customer_details?.name
                    )}
                  </div>
                  <div className="noteDesc">
                    Note{" "}
                    <Link
                      to={`#note${item?.custom_note_uuid || item?._id}`}
                      className="note-link"
                    >
                      {" "}
                      {item?.custom_note_uuid || item?._id}
                    </Link>
                    &nbsp;&nbsp; | &nbsp;&nbsp;
                    {moment(item?.created_at).format(
                      process.env.REACT_APP_DATE_TIME_FORMAT
                    )}
                  </div>
                </div>
              </div>
              <div
                className="note-text"
                dangerouslySetInnerHTML={{
                  __html: item.note_content,
                }}
              ></div>
              {item.hasOwnProperty("attachment") &&
                Object.keys(item["attachment"]).length > 0 && (
                  <div className="afterupload-image">
                    {item.hasOwnProperty("attachment") &&
                    Object.keys(item["attachment"]).length > 0
                      ? Object.keys(item["attachment"]).map((itt, inn) => {
                          return (
                            <div
                              className="img-box"
                              key={inn}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <ImagePreview
                                itt={itt}
                                item={item}
                                imgLength={Object.keys(item["attachment"]).map(
                                  (ite) => item["attachment"][ite]
                                )}
                                height="58px"
                                width="128px"
                              />
                              <figure>
                                {item?.["attachment"][itt]?.file_name?.slice(
                                  0,
                                  7
                                ) +
                                  "." +
                                  item?.["attachment"][itt]?.file_name
                                    ?.split(".")
                                    ?.pop()}
                              </figure>
                            </div>
                          );
                        })
                      : null}
                  </div>
                )}
            </div>
          </div>
        </div>
      );
    }
  };*/

  getNoteBody = (item, index) => {
    if (item.note_type === "customer") {
      return (
        <div
          className="row justify-content-end"
          key={index}
          id={`note${item?.custom_note_uuid || item?.id || item?._id}`}
        >
          <div className="col-lg-11">
            <div className="other-singlebox">
              <div className="topPart d-flex justify-content-start align-items-center">
                <div className="left-side firstLetter">
                  <img
                    src={`${item?.customer_details?.profile_image || Frame}`}
                  />
                </div>
                <div className="right-side">
                  <div className="name">
                    {item.customer_details?.profile_url ? (
                      <a
                        target={"_blank"}
                        href={item?.customer_details?.profile_url}
                        className="checkUserNameNote"
                      >
                        {" "}
                        {item?.customer_details?.name}
                      </a>
                    ) : (
                      item?.customer_details?.name
                    )}
                  </div>
                  <div className="noteDesc">
                    Note{" "}
                    <Link
                      to={`#note${item?.custom_note_uuid || item?.id || item?._id}`}
                      className="note-link"
                    >
                      {" "}
                      {item?.custom_note_uuid || item?.id || item?._id}
                    </Link>
                    &nbsp;&nbsp; | &nbsp;&nbsp;
                    {moment(item?.created_at).format(
                      process.env.REACT_APP_DATE_TIME_FORMAT,
                    )}
                  </div>
                </div>
              </div>
              <GmailReplyCollapse
                content={item.note_content}
                className="note-text"
              />

              {item.email_attachments && <NotesAttatchment item={item} />}
              {item.hasOwnProperty("attachment") &&
                Object.keys(item["attachment"]).length > 0 && (
                  <div className="afterupload-image">
                    {item.hasOwnProperty("attachment") &&
                    Object.keys(item["attachment"]).length > 0
                      ? Object.keys(item["attachment"]).map((itt, inn) => {
                          return (
                            <div
                              className="img-box"
                              key={inn}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <ImagePreview
                                itt={itt}
                                item={item}
                                imgLength={Object.keys(item["attachment"]).map(
                                  (ite) => item["attachment"][ite],
                                )}
                                height="58px"
                                width="128px"
                              />
                              <figure>
                                {item?.["attachment"][itt]?.file_name?.slice(
                                  0,
                                  7,
                                ) +
                                  "." +
                                  item?.["attachment"][itt]?.file_name
                                    ?.split(".")
                                    ?.pop()}
                              </figure>
                            </div>
                          );
                        })
                      : null}
                  </div>
                )}
            </div>
          </div>
        </div>
      );
    } else {
      if (this.state.is_external) {
        if (item.hasOwnProperty("is_external") && item.is_external === 1) {
          //show in left
          return this.getNoteAlignment("justify-content-start", item, index);
        } else {
          //show in right
          return this.getNoteAlignment("justify-content-end", item, index);
        }
      } else {
        if (item.hasOwnProperty("is_external") && item.is_external === 1) {
          //show in right
          return this.getNoteAlignment("justify-content-end", item, index);
        } else {
          //show in left
          return this.getNoteAlignment("justify-content-start", item, index);
        }
      }
    }
  };

  isDateValidate = (dateone, datetwo, field) => {
    let valid = true;
    if (field === "start_date") {
      // start date will verify with other date like end date and go live date if these are available
      if (
        datetwo.hasOwnProperty("end_date") ||
        datetwo.hasOwnProperty("go_live_date")
      ) {
        if (
          dateone > datetwo["end_date"] ||
          dateone > datetwo["go_live_date"]
        ) {
          valid = false;
        } else {
          valid = true;
        }
      }
    }

    if (field === "end_date") {
      // end will verify with start date which should not less than it and should not greater than go live date
      if (
        datetwo.hasOwnProperty("start_date") ||
        datetwo.hasOwnProperty("go_live_date")
      ) {
        if (
          dateone < datetwo["start_date"] ||
          dateone > datetwo["go_live_date"]
        ) {
          valid = false;
        } else {
          valid = true;
        }
      }
    }
    if (field === "go_live_date") {
      // this will check the which should not less then end date and start date and others date if available
      if (
        datetwo.hasOwnProperty("start_date") ||
        datetwo.hasOwnProperty("end_date") ||
        datetwo.hasOwnProperty("qa_start_date") ||
        datetwo.hasOwnProperty("qa_end_date")
      ) {
        if (
          dateone < datetwo["start_date"] ||
          dateone < datetwo["end_date"] ||
          dateone < datetwo["qa_start_date"] ||
          dateone < datetwo["qa_end_date"]
        ) {
          valid = false;
        } else {
          valid = true;
        }
      }
    }
    if (field === "qa_start_date") {
      // will check qa start date should not greater than the qa_end_date and go_live_date

      if (
        datetwo.hasOwnProperty("qa_end_date") ||
        datetwo.hasOwnProperty("go_live_date")
      ) {
        if (
          dateone > datetwo["qa_end_date"] ||
          dateone > datetwo["go_live_date"]
        ) {
          valid = false;
        } else {
          valid = true;
        }
      }
    }

    if (field === "qa_end_date") {
      // will check qa end date should not less than qa start date not greater than the go live date

      if (
        datetwo.hasOwnProperty("qa_start_date") ||
        datetwo.hasOwnProperty("go_live_date")
      ) {
        if (
          dateone < datetwo["qa_start_date"] ||
          dateone > datetwo["go_live_date"]
        ) {
          valid = false;
        } else {
          valid = true;
        }
      }
    }

    return valid;
  };
  convertDateFormat = (date) => {
    let convertdate = null;
    if (date) {
      convertdate = moment(date).format("YYYY-MM-DD");
    }
    return convertdate;
  };
  reasonDatePickerChange = (evt, field) => {
    const date = this.convertDateFormat(evt);
    let reasonaskingdata = { ...this.state.reasonaskingdata };
    // if (
    //   field === "start_date" &&
    //   !this.isDateValidate(
    //     date,
    //     this.state.reasonaskingdata["end_date"] || this.state.rows["end_date"],
    //     field
    //   )
    // ) {
    //   this.setState((state) => {
    //     return {
    //       ...state,
    //       createBoard: {
    //         ...state.createBoard,
    //         board: true,
    //         message: "start date should not greater than end date",
    //         bg: "danger",
    //         title: "Error",
    //       },
    //     };
    //   });
    //   return;
    // }
    // if (
    //   field === "end_date" &&
    //   !this.isDateValidate(
    //     date,
    //     this.state.reasonaskingdata["go_live_date"] ||
    //       this.state.rows["go_live_date"],
    //     field
    //   )
    // ) {
    //   this.setState((state) => {
    //     return {
    //       ...state,
    //       createBoard: {
    //         ...state.createBoard,
    //         board: true,
    //         message: "end date should not greater than go live date",
    //         bg: "danger",
    //         title: "Error",
    //       },
    //     };
    //   });
    //   return;
    // }
    // if (
    //   field === "go_live_date" &&
    //   !this.isDateValidate(
    //     date,
    //     this.state.reasonaskingdata["end_date"] || this.state.rows["end_date"],
    //     field
    //   )
    // ) {
    //   this.setState((state) => {
    //     return {
    //       ...state,
    //       createBoard: {
    //         ...state.createBoard,
    //         board: true,
    //         message: "Go live date shouldn't less than end date",
    //         bg: "danger",
    //         title: "Error",
    //       },
    //     };
    //   });
    //   return;
    // }
    reasonaskingdata[field] = date;
    let formerrordate = { ...this.state.populateFormError };
    if (date) {
      formerrordate[field] = "";

      const values = Object.values(formerrordate);

      const result = values.every((item) => item === "");

      this.setState((state) => {
        return {
          ...state,
          buttonDisabled: !result,
        };
      });
    } else {
      if (field !== "go_live_date") {
        ((formerrordate[field] = `${field
          .split("_")
          .map((it, index) => {
            return it === "qa" && index === 0
              ? it.toUpperCase()
              : it === "end" && index === 0
                ? "Dev End"
                : it === "start" && index === 0
                  ? "Dev Start"
                  : it;
          })
          .join(" ")} is required`),
          this.setState((state) => {
            return {
              ...state,

              buttonDisabled: true,
            };
          }));
      }
    }
    this.setState((state) => {
      return {
        ...state,
        reasonaskingdata,
        populateFormError: formerrordate,
      };
    });
  };
  reasonValueChange = (evt, field) => {
    const { name, value } = evt.target;

    let reasonaskingdata = { ...this.state.reasonaskingdata };
    ((reasonaskingdata[field] = value || target.value),
      this.setState((state) => {
        return {
          ...state,
          reasonaskingdata,
        };
      }));
  };
  longTextEditHandler = (item) => {
    let alleditfile = { ...this.state.long_text_edit };
    alleditfile[item.field] = true;
    this.setState((state) => {
      return {
        ...state,
        long_text_edit: alleditfile,
      };
    });
  };
  closeModal = () => {
    this.setState({ ...this.state, isDelete: false });
  };

  removeAttachmentHandler = (uuid) => {
    this.setState({ ...this.state, removeAttachmentId: uuid, isDelete: true });
  };

  deleteConfirmHandler = async () => {
    // this.props.removeTattleAttachment(this.state.removeAttachmentId);
    let images = { ...this.state.rows?.attachment };
    images = {
      ...delete images[this.state.removeAttachmentId],
      ...images,
    };
    const data = {
      app_token: this.state.boarddata.app_token,
      user_uuid: this.state.boarddata.user_uuid,
      attribute_set_key: this.props.match.params.attribute_set_key,
      customer_tattle_uuid: +this.props.match.params.id,
      attribute_key: "attachment",
      file_uuid: this.state.removeAttachmentId,
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}attachment/delete`,
        {
          method: "POST",
          body: JSON.stringify(data),
        },
      );
      const rdata = await response.json();
      if (rdata.code === 200) {
        this.setState({
          ...this.state,
          isDelete: false,
          rows: {
            ...this.state.rows,
            attachment: images,
          },
          // createBoard: {
          //   ...this.state.createBoard,
          //   board: true,
          //   title: "success",
          //   message: rdata.message,
          //   title: rdata.status,
          //   bg: "primary",
          // },
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  disabledCategory = () => {
    setTimeout(() => {
      this.setState((state) => {
        return {
          ...state,
          isChangingCategory: true,
        };
      });
    });
  };
  getCallBackButton = () => {
    if (this.state.boarddata.has_parent) {
      return (
        <Back
          to={`/tattle/${this.state.boarddata.parent_attribute_set_key}/${this.state.rows["er"]}`}
          className="txt-dark underline-none m-0"
        />
      );
    }

    if (this.state.boarddata.attribute_set_type === 4) {
      return (
        <Back
          to={`/tattle/${this.props.match.params.attribute_set_key}/kanban`}
          className="txt-dark underline-none m-0"
          onClick={this.goTotheHistory}
        />
      );
    }
    return (
      <Back
        to={`/tattle/${this.state.boarddata.attribute_set_key}/list${this.state.boarddata.main_attribute_set_key ? "/" + this.state.boarddata.main_attribute_set_key : ""}`}
        className="txt-dark underline-none m-0"
        onClick={this.goTotheHistory}
      />
    );
  };
  callCtaActionHandler = async (cta, details) => {
    const response = await fetch(cta, {
      method: "POST",
      body: JSON.stringify(details),
    });
    const rdata = await response.json();
    return rdata;
  };
  linkifyClick = () => {
    this.setState((state) => {
      return {
        ...state,
        isLinkify: true,
      };
    });
  };

  checkFieldCondition = (conditionObj, rows) => {
    if (!conditionObj) return true;
    const fieldValue = rows[conditionObj.key];

    switch (conditionObj.condition) {
      case "includes":
        // field value is array
        if (Array.isArray(fieldValue)) {
          return conditionObj.value.some((val) => fieldValue.includes(val));
        }

        // field value is single value
        return conditionObj.value.includes(fieldValue);

      case "=":
        return fieldValue === conditionObj.value;

      case "!=":
        return fieldValue !== conditionObj.value;

      default:
        return false;
    }
  };

  disabledLinkify = () => {
    this.setState((state) => {
      return {
        ...state,
        isLinkify: false,
      };
    });
  };
  render() {
    const {
      details,
      planning_date,
      people,
      status,
      title,
      description,
      feature,
      hidden_panel,
      long_text,
      dev_project_plan,
      qa_project_plan,
      scrum_project_plan,
      release_pane,
    } = this.state;
    const { attachment = {} } = this.state.rows || {};

    let toolbar;
    if (this.state.rows && description?.length > 0) {
      if (this.state.descEdit) {
        console.log("description[0]", description[0].min_length);
        toolbar = (
          <>
            {" "}
            <Error>
              <ToolBar
                value={
                  !this.state.validDescription
                    ? this.state?.rows[description[0]?.field]
                    : ""
                }
                description={description?.[0]}
                getRawData={this.getToolBarData}
                fileFalse={false}
                name={description[0]?.field}
                linkifyClick={this.linkifyClick}
                onBlurClose={() =>
                  !this.state.isLinkify && this.onBlurClose(description[0])
                }
                disabledLinkify={this.disabledLinkify}
                onError={this.getError}
                refs={this.toolbarRef}
                min_length={description[0].min_length ?? false}
              />
              <span className="error-feedback">
                {this.state.validDescription && this.state.validDescription}
              </span>
            </Error>
          </>
        );
      } else {
        const new_html = this.state?.rows[description?.[0]?.field];
        var Rexp = /((https?|ftps?):\/\/[^"<\s]+)(?![^<>]*>|[^"]*?<\/a)/gi;
        let html = new_html?.replace(
          Rexp,
          `<a target="_blank" href="$1">$1<a/>`,
        );
        toolbar = (
          <>
            {" "}
            <div
              style={
                !this.state?.rows[description?.[0]?.field]
                  ? { height: "10px" }
                  : { height: "auto" }
              }
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: html,
                }}
              ></span>
            </div>
          </>
        );
      }
    }

    let attr;
    let featuresec;

    if (details?.length > 0) {
      const [nstatus] = status ?? [];

      attr = details.map((item, index) => {
        const par = JSON.parse(this.props.boardData?.attribute_config || "{}");

        const fieldCondition = par?.[item?.field];

        // if field not found continue/show
        if (
          fieldCondition &&
          !this.checkFieldCondition(fieldCondition, this.state.rows)
        ) {
          return null;
        }

        return (
          <Error key={index}>
            <ReadOnlyField
              {...item}
              rows={{ ...this.state.rows }}
              key={index}
              checkError={this.checkError}
              status={nstatus}
              isStatusChanging={this.state.isStatusChanging}
              currentSelectedStatusName={this.state.currentSelectedStatusName}
              type={item.details_pane}
              disabledCategory={this.disabledCategory}
              showInlne={(type, obj) =>
                this.showInlineHandler(index, type, obj)
              }
              removeAllEditInline={() => this.removeAllEditInline("details")}
              dataSubmit={this.dataSubmit}
              users={this.state.users || {}}
              submitProjectHandler={this.submitProjectHandler}
              AddMonitorHandler={this.AddMonitorHandler}
              erroSetup={(type, errors) =>
                this.setupErrorHandler(index, type, errors)
              }
              boarddata={this.state.boarddata}
              removeMonitorFromAddMonitor={this.removeMonitorFromAddMonitor}
              reasonAsking={this.reasonAsking}
              dependencyAsking={this.dependencyAsking}
              removeItemHandler={this.removeItemHandler}
              SlaHighlight={
                this.state.rows.sla_fields?.includes(item.field) ? true : false
              }
              slaReason={this.getSlaMissedReasonByField(item.field)}
              app_token={this.state.boarddata.app_token}
            />
          </Error>
        );
      });
    }
    if (feature?.length > 0) {
      const [nstatus] = status ?? [];
      featuresec = feature.map((item, index) => {
        const par = JSON.parse(this.props.boardData?.attribute_config || "{}");

        const fieldCondition = par?.[item?.field];

        // if field not found continue/show
        if (
          fieldCondition &&
          !this.checkFieldCondition(fieldCondition, this.state.rows)
        ) {
          return null;
        }
        return (
          <Error>
            <ReadOnlyField
              {...item}
              rows={{ ...this.state.rows }}
              key={index}
              checkError={this.checkError}
              status={nstatus}
              className="grid-one-column"
              isStatusChanging={this.state.isStatusChanging}
              currentSelectedStatusName={this.state.currentSelectedStatusName}
              type={item.details_pane}
              disabledCategory={this.disabledCategory}
              showInlne={(type, obj) =>
                this.showInlineHandler(index, type, obj)
              }
              removeAllEditInline={() => this.removeAllEditInline("feature")}
              dataSubmit={this.dataSubmit}
              users={this.state.users || {}}
              submitProjectHandler={this.submitProjectHandler}
              AddMonitorHandler={this.AddMonitorHandler}
              erroSetup={(type, errors) =>
                this.setupErrorHandler(index, type, errors)
              }
              boarddata={this.state.boarddata}
              removeMonitorFromAddMonitor={this.removeMonitorFromAddMonitor}
              reasonAsking={this.reasonAsking}
              dependencyAsking={this.dependencyAsking}
              removeItemHandler={this.removeItemHandler}
              SlaHighlight={
                this.state.rows.sla_fields?.includes(item.field) ? true : false
              }
              slaReason={this.getSlaMissedReasonByField(item.field)}
            />
          </Error>
        );
      });
    }
    let release;
    if (release_pane?.length > 0) {
      const [nstatus] = status ?? [];
      release = release_pane.map((item, index) => {
        const par = JSON.parse(this.props.boardData?.attribute_config || "{}");

        const fieldCondition = par?.[item?.field];

        // if field not found continue/show
        if (
          fieldCondition &&
          !this.checkFieldCondition(fieldCondition, this.state.rows)
        ) {
          return null;
        }
        return (
          <Error>
            <ReadOnlyField
              {...item}
              rows={{ ...this.state.rows }}
              checkError={this.checkError}
              key={index}
              status={nstatus}
              isStatusChanging={this.state.isStatusChanging}
              currentSelectedStatusName={this.state.currentSelectedStatusName}
              type={item.details_pane}
              disabledCategory={this.disabledCategory}
              showInlne={(type, obj) =>
                this.showInlineHandler(index, type, obj)
              }
              removeAllEditInline={() =>
                this.removeAllEditInline("release_pane")
              }
              dataSubmit={this.dataSubmit}
              users={this.state.users || {}}
              submitProjectHandler={this.submitProjectHandler}
              AddMonitorHandler={this.AddMonitorHandler}
              erroSetup={(type, errors) =>
                this.setupErrorHandler(index, type, errors)
              }
              boarddata={this.state.boarddata}
              removeMonitorFromAddMonitor={this.removeMonitorFromAddMonitor}
              reasonAsking={this.reasonAsking}
              dependencyAsking={this.dependencyAsking}
              removeItemHandler={this.removeItemHandler}
              SlaHighlight={
                this.state.rows.sla_fields?.includes(item.field) ? true : false
              }
              slaReason={this.getSlaMissedReasonByField(item.field)}
            />
          </Error>
        );
      });
    }
    let hidden_pane;
    if (hidden_panel?.length > 0) {
      const [nstatus] = status ?? [];
      hidden_pane = hidden_panel.map((item, index) => {
        const par = JSON.parse(this.props.boardData?.attribute_config || "{}");

        const fieldCondition = par?.[item?.field];

        // if field not found continue/show
        if (
          fieldCondition &&
          !this.checkFieldCondition(fieldCondition, this.state.rows)
        ) {
          return null;
        }
        return (
          <Error>
            <ReadOnlyField
              {...item}
              checkError={this.checkError}
              rows={{ ...this.state?.rows }}
              key={index}
              status={nstatus}
              type={item.details_pane}
              showInlne={(type, obj) =>
                this.showInlineHandler(index, type, obj)
              }
              currentSelectedStatusName={this.state.currentSelectedStatusName}
              disabledCategory={this.disabledCategory}
              isStatusChanging={this.state.isStatusChanging}
              removeAllEditInline={() =>
                this.removeAllEditInline("hidden_panel")
              }
              users={this.state.users || {}}
              submitProjectHandler={this.submitProjectHandler}
              dataSubmit={this.dataSubmit}
              AddMonitorHandler={this.AddMonitorHandler}
              erroSetup={(type, errors) =>
                this.setupErrorHandler(index, type, errors)
              }
              boarddata={this.state.boarddata}
              removeMonitorFromAddMonitor={this.removeMonitorFromAddMonitor}
              reasonAsking={this.reasonAsking}
              dependencyAsking={this.dependencyAsking}
              removeItemHandler={this.removeItemHandler}
              SlaHighlight={
                this.state.rows.sla_fields?.includes(item.field) ? true : false
              }
              slaReason={this.getSlaMissedReasonByField(item.field)}
            />
          </Error>
        );
      });
    }

    let peope;

    if (people?.length > 0) {
      const [nstatus] = status ?? [];
      peope = people.map((item, index) => {
        const par = JSON.parse(this.props.boardData?.attribute_config || "{}");

        const fieldCondition = par?.[item?.field];

        // if field not found continue/show
        if (
          fieldCondition &&
          !this.checkFieldCondition(fieldCondition, this.state.rows)
        ) {
          return null;
        }
        return (
          <Error>
            <ReadOnlyField
              {...item}
              checkError={this.checkError}
              rows={{ ...this.state.rows }}
              key={index}
              type={item.details_pane}
              status={nstatus}
              disabledCategory={this.disabledCategory}
              isStatusChanging={this.state.isStatusChanging}
              showInlne={(type, obj) =>
                this.showInlineHandler(index, type, obj)
              }
              removeAllEditInline={() => this.removeAllEditInline("people")}
              className="backcheck"
              currentSelectedStatusName={this.state.currentSelectedStatusName}
              newMonitor={this.state.newMonitor}
              users={this.state.users || {}}
              dataSubmit={this.dataSubmit}
              submitProjectHandler={this.submitProjectHandler}
              AddMonitorHandler={this.AddMonitorHandler}
              erroSetup={(type, errors) =>
                this.setupErrorHandler(index, type, errors)
              }
              boarddata={this.state.boarddata}
              removeMonitorFromAddMonitor={this.removeMonitorFromAddMonitor}
              reasonAsking={this.reasonAsking}
              dependencyAsking={this.dependencyAsking}
              removeItemHandler={this.removeItemHandler}
              SlaHighlight={
                this.state.rows.sla_fields?.includes(item.field) ? true : false
              }
              slaReason={this.getSlaMissedReasonByField(item.field)}
            />
          </Error>
        );
      });
    }
    let plannindDate;
    if (planning_date?.length > 0) {
      const [nstatus] = status ?? [];
      plannindDate = planning_date.map((item, index) => {
        const par = JSON.parse(this.props.boardData?.attribute_config || "{}");

        const fieldCondition = par?.[item?.field];

        // if field not found continue/show
        if (
          fieldCondition &&
          !this.checkFieldCondition(fieldCondition, this.state.rows)
        ) {
          return null;
        }
        return (
          <Error>
            <ReadOnlyField
              {...item}
              checkError={this.checkError}
              rows={{ ...this.state.rows }}
              key={index}
              users={this.state.users || {}}
              type={item.details_pane}
              status={nstatus}
              disabledCategory={this.disabledCategory}
              isStatusChanging={this.state.isStatusChanging}
              currentSelectedStatusName={this.state.currentSelectedStatusName}
              showInlne={(type, obj) =>
                this.showInlineHandler(index, type, obj)
              }
              removeAllEditInline={() =>
                this.removeAllEditInline("planning_date")
              }
              className="backcheck"
              dataSubmit={this.dataSubmit}
              submitProjectHandler={this.submitProjectHandler}
              AddMonitorHandler={this.AddMonitorHandler}
              erroSetup={(type, errors) =>
                this.setupErrorHandler(index, type, errors)
              }
              boarddata={this.state.boarddata}
              removeMonitorFromAddMonitor={this.removeMonitorFromAddMonitor}
              reasonAsking={this.reasonAsking}
              dependencyAsking={this.dependencyAsking}
              removeItemHandler={this.removeItemHandler}
              SlaHighlight={
                this.state.rows.sla_fields?.includes(item.field) ? true : false
              }
              slaReason={this.getSlaMissedReasonByField(item.field)}
            />
          </Error>
        );
      });
    }
    let dev_planning_date;
    if (dev_project_plan?.length > 0) {
      const [nstatus] = status ?? [];
      dev_planning_date = dev_project_plan.map((item, index) => {
        const par = JSON.parse(this.props.boardData?.attribute_config || "{}");

        const fieldCondition = par?.[item?.field] || false;

        // if field not found continue/show
        if (
          fieldCondition &&
          !this.checkFieldCondition(fieldCondition, this.state.rows)
        ) {
          return null;
        }
        return (
          <Error>
            <ReadOnlyField
              {...item}
              checkError={this.checkError}
              rows={{ ...this.state.rows }}
              key={index}
              type={item.details_pane}
              status={nstatus}
              disabledCategory={this.disabledCategory}
              isStatusChanging={this.state.isStatusChanging}
              showInlne={(type, obj) =>
                this.showInlineHandler(index, type, obj)
              }
              removeAllEditInline={() =>
                this.removeAllEditInline("dev_project_plan")
              }
              users={this.state.users || {}}
              className="backcheck"
              dataSubmit={this.dataSubmit}
              submitProjectHandler={this.submitProjectHandler}
              AddMonitorHandler={this.AddMonitorHandler}
              erroSetup={(type, errors) =>
                this.setupErrorHandler(index, type, errors)
              }
              boarddata={this.state.boarddata}
              removeMonitorFromAddMonitor={this.removeMonitorFromAddMonitor}
              reasonAsking={this.reasonAsking}
              dependencyAsking={this.dependencyAsking}
              removeItemHandler={this.removeItemHandler}
              SlaHighlight={
                this.state.rows.sla_fields?.includes(item.field) ? true : false
              }
              slaReason={this.getSlaMissedReasonByField(item.field)}
            />
          </Error>
        );
      });
    }

    let qa_planning_date;
    if (qa_project_plan?.length > 0) {
      const [nstatus] = status ?? [];
      qa_planning_date = qa_project_plan.map((item, index) => {
        const par = JSON.parse(this.props.boardData?.attribute_config || "{}");

        const fieldCondition = par?.[item?.field];

        // if field not found continue/show
        if (
          fieldCondition &&
          !this.checkFieldCondition(fieldCondition, this.state.rows)
        ) {
          return null;
        }
        return (
          <Error>
            <ReadOnlyField
              {...item}
              rows={{ ...this.state.rows }}
              key={index}
              checkError={this.checkError}
              type={item.details_pane}
              status={nstatus}
              disabledCategory={this.disabledCategory}
              isStatusChanging={this.state.isStatusChanging}
              showInlne={(type, obj) =>
                this.showInlineHandler(index, type, obj)
              }
              removeAllEditInline={() =>
                this.removeAllEditInline(item.details_pane)
              }
              className="backcheck"
              dataSubmit={this.dataSubmit}
              submitProjectHandler={this.submitProjectHandler}
              AddMonitorHandler={this.AddMonitorHandler}
              erroSetup={(type, errors) =>
                this.setupErrorHandler(index, type, errors)
              }
              users={this.state.users || {}}
              boarddata={this.state.boarddata}
              removeMonitorFromAddMonitor={this.removeMonitorFromAddMonitor}
              reasonAsking={this.reasonAsking}
              dependencyAsking={this.dependencyAsking}
              removeItemHandler={this.removeItemHandler}
              SlaHighlight={
                this.state.rows.sla_fields?.includes(item.field) ? true : false
              }
              slaReason={this.getSlaMissedReasonByField(item.field)}
            />
          </Error>
        );
      });
    }
    let scrum_planning_date;
    if (scrum_project_plan?.length > 0) {
      const [nstatus] = status ?? [];
      scrum_planning_date = scrum_project_plan.map((item, index) => {
        const par = JSON.parse(this.props.boardData?.attribute_config || "{}");

        const fieldCondition = par?.[item?.field];

        // if field not found continue/show
        if (
          fieldCondition &&
          !this.checkFieldCondition(fieldCondition, this.state.rows)
        ) {
          return null;
        }
        return (
          <Error>
            <ReadOnlyField
              {...item}
              rows={{ ...this.state.rows }}
              key={index}
              checkError={this.checkError}
              type={item.details_pane}
              status={nstatus}
              disabledCategory={this.disabledCategory}
              isStatusChanging={this.state.isStatusChanging}
              showInlne={(type, obj) =>
                this.showInlineHandler(index, type, obj)
              }
              removeAllEditInline={() =>
                this.removeAllEditInline(item.details_pane)
              }
              users={this.state.users || {}}
              className="backcheck"
              dataSubmit={this.dataSubmit}
              submitProjectHandler={this.submitProjectHandler}
              AddMonitorHandler={this.AddMonitorHandler}
              erroSetup={(type, errors) =>
                this.setupErrorHandler(index, type, errors)
              }
              boarddata={this.state.boarddata}
              removeMonitorFromAddMonitor={this.removeMonitorFromAddMonitor}
              reasonAsking={this.reasonAsking}
              dependencyAsking={this.dependencyAsking}
              removeItemHandler={this.removeItemHandler}
              SlaHighlight={
                this.state.rows.sla_fields?.includes(item.field) ? true : false
              }
              slaReason={this.getSlaMissedReasonByField(item.field) || ""}
            />
          </Error>
        );
      });
    }

    return (
      <>
        <Modal
          show={this.state.isDelete}
          className="confirm"
          close={this.closeModal}
        >
          <div className="deleteAlert">
            <p>Are you sure you want delete the attachment?</p>
            <div className="actionDelete">
              <Button
                className="muBtn _blue"
                text="Yes"
                onClick={() => this.deleteConfirmHandler()}
              />{" "}
              &nbsp;
              <Button
                className="muBtn _grey"
                text="Cancel"
                onClick={this.closeModal}
              />
            </div>
          </div>
        </Modal>
        {this.state.reasonModal && (
          <Error>
            <Modal show={this.state.reasonModal} close={this.closeReasonModal}>
              <Row>
                <Col md={12}>
                  <form onSubmit={this.onReasonSubmitHandler}>
                    <div className="dynamicReasonAsking">
                      {this.state.isStatusChanged ? (
                        <div className="form-group">
                          <label>Status</label> :{" "}
                          {this.state.isStatusChanged
                            ? this.state.pauseSelectStatus.name
                            : this.state.selectStatus.name}{" "}
                        </div>
                      ) : (
                        this.populateForm(
                          this.state.reasonFilteredField,
                          this.state.reasonaskingdata,
                        )
                      )}
                    </div>

                    <div className="form-group dynamicReasonnote">
                      <label>
                        Leave a Reason here{" "}
                        <span className="reason_mandatory">
                          <sup>*</sup>
                        </span>{" "}
                      </label>
                      <Error>
                        <ReasonNote
                          getRawData={this.getReasonData}
                          users={this.state.users}
                          addnote={true}
                          toolbar={true}
                          isAdding={this.state.isAddReason}
                          customer_tattle_uuid={Number(
                            this.props.match.params.id,
                          )}
                          //note_type={this.state.noteType}
                          note_type={this.state.note_type}
                          attribute_set_key={
                            this.props.match.params.attribute_set_key
                          }
                          button={true}
                          buttonText="Add Reason"
                          buttonDisabled={this.state.buttonDisabled}
                        />
                      </Error>
                    </div>
                  </form>
                </Col>
              </Row>
            </Modal>
          </Error>
        )}
        {this.state.has_dependencies && (
          <DependenciesModal
            show={this.state.has_dependencies}
            close={this.closeDependenciesModal}
            className={"dependencies-modal"}
            title={
              this.state.dependencyModalTitle ||
              "Update required for the below fields"
            }
            dependencies={this.state.dependencies}
            status={this.state.dependencySelectStatus}
            board_attributes={this.state?.board_attributes}
            boarddata={this.state.boarddata}
            users={this.state.users}
            rows={{
              ...this.state.rows,
              ...(this.state.pendingDependencyEdit?.singleEdit || {}),
            }}
            onSubmit={this.handleDependencyStatusSubmit}
          />
        )}
        {/* {this.props.attributes.imageUpload[this.props.match.params.id] &&
          Object?.keys(this.props.attributes.imageUpload).length > 0 && (
            <Uploader show={true} />
          )} */}
        <Error>
          <Modal
            show={this.state.attachShow}
            className="tattle-Uppopup"
            close={this.hideUiModal}
            title="Upload Your File"
            footer-margin="mb-3"
          >
            {this.getModalContent()}
          </Modal>
        </Error>

        {this.state.showMonitor && (
          <Error>
            <AddMonitorModal
              monitor={this.state.showMonitor}
              close={this.monitorModalClose}
              newmonitor={this.state.newMonitor}
              users={this.state.users}
              isAddingButton={this.state.isAddingButton}
              isMultiple={this.state.isMultiple ? true : false}
              addingNewMonitorHandler={this.addingNewMonitorHandler}
              removeMonitorHandler={this.removeMonitorHandler}
              removeIdMonitoring={this.state.removeIdMonitoring}
            />
          </Error>
        )}
        {this.state.createBoard.board && (
          <Error>
            <Message board={this.state.createBoard} />
          </Error>
        )}

        <div className="mainContent-panel-wrap">
          <Error>
            <Header
              brecum_name={{ name: "View", link: "list" }}
              brecum_page={this.state.boarddata.attribute_set_name}
              pageName="view"
            />
          </Error>
          <div className="main_custom_class">
            <NewCustomFilter
              filters={this.state.boarddata.filter}
              isView={true}
              isAdmin={this.state.boarddata.is_admin == 1 ? 1 : 0}
              enebleClickFilter={() => this.createFilter(0)}
              attribute_set_type={this.state.boarddata.attribute_set_type}
              enebleAdvancedClickFilter={() => this.createFilter(1)}
              main_attribute_set_key={this.state.boarddata.attribute_set_key}
            />
            <Container fluid className="g-0">
              {Object.keys(this.state.rows).length > 0 ? (
                <div
                  className="page-content pt-1 new-content-main"
                  style={!this.props.toggleMenu ? { marginLeft: "181px" } : {}}
                >
                  {/* <p className="col-form-label txt-dark d-flex pb-0">
                    <Back
                      name="Back"
                      to={`/tattle/${this.props.match.params.attribute_set_key}/list`}
                      className="txt-dark underline-none"
                    />
                  </p> */}

                  <div className="details-fullpage">
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={8}
                        lg={9}
                        className="right-border-top-class"
                      >
                        {" "}
                        <div className="top-header-title mt-2 mb-2">
                          <div className="erTop-title">
                            {this.getCallBackButton()}
                            {this.getTitleBoard(title)}
                          </div>
                        </div>
                        <div className="statusLinkBlock mb-2">
                          <div className="afterTitle-block">
                            {this.state.boarddata.has_parent === 0 && (
                              <div className="ernNo">
                                ID :
                                <Link to={`./${this.props.match.params.id}`}>
                                  {this.props.match.params.id}
                                </Link>
                              </div>
                            )}
                            {this.state.boarddata.attribute_set_type == 2 &&
                              this.getCopyLinkButton()}
                            {this.getAttachmentButton()}
                            {this.getErButton()}
                            {this.state.boarddata.attribute_set_type === 3 &&
                              !this.state.boarddata.main_attribute_set_key && (
                                <Link
                                  className="cta"
                                  to={{
                                    pathname: `/tattle/${this.props.match.params.attribute_set_key}/clone/${this.props.match.params.id}`,
                                    state: {
                                      prevPath: this.props.location.pathname,
                                    },
                                  }}
                                >
                                  Clone
                                </Link>
                              )}
                            <CtaComponent
                              cta={this.props.boardData?.cta || []}
                              callCtaActionHandler={this.callCtaActionHandler}
                            />
                          </div>
                        </div>
                        {this.state.board_attributes &&
                        this.state.board_attributes.hasOwnProperty(
                          "description",
                        ) ? (
                          <div className="description-block mb-2">
                            <div className="desc">{toolbar}</div>
                            {!this.state.descEdit && (
                              <div
                                className="new-inline-edit"
                                onClick={() =>
                                  !description?.[0].readonly &&
                                  this.editDescriptionHandler()
                                }
                              >
                                <div>
                                  <i
                                    class="fa fa-pencil"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.attachment_pane.length > 0 &&
                          Object.keys(attachment || {}).length > 0 && (
                            <div className="afterupload-image tattle-images-view mb-2">
                              {Object.keys(attachment).map((item, index) => {
                                return (
                                  <div className="gallery" key={index}>
                                    <ImagePreview
                                      headImage={attachment[item]}
                                      className="newchild_upload"
                                      width="128px"
                                      height="58px"
                                    />

                                    <div className="delete">
                                      <svg
                                        width="11"
                                        height="10"
                                        viewBox="0 0 11 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{
                                          marginLeft: "-1px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          this.removeAttachmentHandler(item)
                                        }
                                      >
                                        <path
                                          d="M8.21973 2.5L3.21973 7.5"
                                          stroke="#737373"
                                          stroke-width="1.33"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></path>
                                        <path
                                          d="M3.21973 2.5L8.21973 7.5"
                                          stroke="#737373"
                                          stroke-width="1.33"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></path>

                                        <title>Remove</title>
                                      </svg>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        {long_text && long_text.length ? (
                          <div className="description-block">
                            {long_text.length > 0 &&
                              long_text.map((item, index) => {
                                if (this.state?.rows[item.field]) {
                                  const new_html = this.state?.rows[item.field];
                                  var Rexp =
                                    /((https?|ftps?):\/\/[^"<\s]+)(?![^<>]*>|[^"]*?<\/a)/gi;
                                  let html;
                                  if (
                                    this.state.isLongText?.[item.field]?.long
                                  ) {
                                    html = new_html?.replace(
                                      Rexp,
                                      `<a target="_blank" href="$1">$1<a/>`,
                                    );
                                  } else {
                                    html = new_html
                                      ?.replace(
                                        Rexp,
                                        `<a target="_blank" href="$1">$1<a/>`,
                                      )
                                      .slice(0, 400);
                                  }

                                  return (
                                    <>
                                      <span className="long_text_edit">
                                        {item.headerName}
                                      </span>
                                      {!this.state.long_text_edit[
                                        item.field
                                      ] ? (
                                        <LongTextEdit
                                          rows={this.state.rows}
                                          html={html}
                                          item={item}
                                          longTextEditHandler={
                                            this.longTextEditHandler
                                          }
                                          showLongTextHandler={
                                            this.showLongTextHandler
                                          }
                                          isLongText={this.state.isLongText}
                                        />
                                      ) : (
                                        <span>
                                          <ToolBar
                                            value={this.state?.rows[item.field]}
                                            getRawData={this.getToolBarData}
                                            fileFalse={false}
                                            name={item.field}
                                            description={item}
                                            onError={this.getErrorLongText}
                                            refs={this.toolbarRef}
                                            linkifyClick={this.linkifyClick}
                                            onBlurClose={() =>
                                              !this.state.isLinkify &&
                                              this.onBlurClose(item)
                                            }
                                            disabledLinkify={
                                              this.disabledLinkify
                                            }
                                          />
                                          <span className="error-feedback">
                                            {this.state.validDescriptionLongText
                                              ? this.state
                                                  .validDescriptionLongText
                                              : ""}
                                          </span>
                                        </span>
                                      )}
                                    </>
                                  );
                                }
                              })}
                          </div>
                        ) : (
                          ""
                        )}
                        {featuresec}
                        {this.props?.match?.params?.attribute_set_key ==
                          "projects" && (
                          <ProgressReport
                            customer_tattle_uuid={this.props.match.params.id}
                            attribute_set_key={
                              this.props.match.params.attribute_set_key
                            }
                            childBoardDataChanged={
                              this.state.childBoardDataChanged
                            }
                            childLoading={this.state.childLoading}
                            progressFilterChanged={this.progressFilterChanged}
                            clearSegmentFun={this.setClearSegment}
                          />
                        )}
                        {/* Feature pane */}
                        <div className="middleLeft-block">
                          {
                            // this.state.boarddata.attribute_set_type == 3 &&
                            this.state.child_boards?.length > 0 &&
                              (this.state.isCallingBoard ? (
                                <Loading />
                              ) : (
                                <div className="storRelatesBlock my-3">
                                  <div className="row">
                                    <Col md={12} lg={12} sm={12} xs={12}>
                                      <div className="tab-block">
                                        <Error>
                                          <ChildBoard
                                            child_board={
                                              this.state.child_boards
                                            }
                                            attributeConfig={JSON.parse(
                                              this.state.boarddata
                                                ?.attribute_config || "{}",
                                            )}
                                            parent_attribute_set_key={
                                              this.state.boarddata
                                                .attribute_set_key
                                            }
                                            changeTheActiveTab={
                                              this.changeTheActiveTab
                                            }
                                            getHistoryData={this.getHistoryData}
                                            attribute_set_type={
                                              this.state.boarddata
                                                .attribute_set_type
                                            }
                                            users={this.state.users || {}}
                                            childBoardDataChanged={
                                              this.childBoardDataChanged
                                            }
                                            filterData={this.state.filterData}
                                            clearSegmentFun={
                                              this.state.clearSegment
                                            }
                                            main_attribute_set_key={
                                              this.state.boarddata
                                                .main_attribute_set_key
                                            }
                                          />
                                        </Error>
                                      </div>
                                    </Col>
                                  </div>
                                </div>
                              ))
                          }

                          <div className="middleLeftBlock">
                            <div className="tab-block view-tab">
                              <Tabs
                                variant="tabs"
                                defaultActiveKey={this.state.activeTabKey}
                                onSelect={this.historyApiCall}
                                activeKey={this.state.activeTabKey}
                              >
                                <Tab
                                  title="Notes"
                                  eventKey="note"
                                  className="note"
                                >
                                  {" "}
                                  {this.state.activeTabKey === "note" && (
                                    <div className="noteRelatesBlock">
                                      {/* <ToolBar value="" /> */}
                                      <div className="d-flex align-items-center justify-content-between">
                                        <label className="inputBox-groupTitle m-0">
                                          Add Notes
                                        </label>
                                        {this.getInternalUi()}{" "}
                                      </div>

                                      <Error>
                                        <Note
                                          getRawData={this.getRawData}
                                          users={this.state.users}
                                          addnote={true}
                                          isAdding={this.state.isAddingNote}
                                          customer_tattle_uuid={Number(
                                            this.props.match.params.id,
                                          )}
                                          note_type={this.state.note_type}
                                          //note_type={this.state.noteType}
                                          attribute_set_key={
                                            this.props.match.params
                                              .attribute_set_key
                                          }
                                          button={false}
                                        />
                                      </Error>
                                      <Error>
                                        <EditNote
                                          show={this.state.editModal}
                                          hideUiModal={this.hideUiModal}
                                          value={
                                            this.state.editNote
                                              .note_content_json ||
                                            this.state.editNote.note_content
                                          }
                                          users={this.state.users}
                                          editNote={this.state.editNote}
                                          submitNote={this.submitNote}
                                        />
                                      </Error>

                                      <Row>
                                        <Col md={12}>
                                          <div className="editNoteContent note_note">
                                            <div className="addNote-Self">
                                              {this.state.notes.length > 0 &&
                                                this.state.notes.map(
                                                  (item, index) =>
                                                    this.getNoteBody(
                                                      item,
                                                      index,
                                                    ),
                                                )}
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  )}
                                </Tab>
                                &nbsp;&nbsp;
                                {!this.state.is_external ? (
                                  <Tab title="History" eventKey="tattleHistory">
                                    {this.state.history.length > 0 &&
                                    this.state.activeTabKey ===
                                      "tattleHistory" ? (
                                      <Error>
                                        <ErHistory
                                          history={this.state.history}
                                          users={this.state.users}
                                          history_attributes={
                                            this.state.history_attributes
                                          }
                                        />
                                      </Error>
                                    ) : (
                                      <Loading />
                                    )}
                                  </Tab>
                                ) : (
                                  ""
                                )}
                              </Tabs>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={4}
                        lg={3}
                        className="g-0 left-border-top-class"
                      >
                        {" "}
                        <div className="stat-block mt-3">
                          {status?.length > 0 && (
                            <div className={`Status`}>
                              <div
                                className={`dropdown bootstrap-select ${this.state.rows.sla_fields && this.state.rows.sla_fields.includes("status") ? "sla-highlight" : ""}`}
                              >
                                <div className="d-flex align-items-center">
                                  <button
                                    type="button"
                                    tabIndex="-1"
                                    className={`btn status_toggle`}
                                    onClick={this.showDropdownHandler}
                                    disabled={
                                      this.state.buttonDisabledStatus ||
                                      this.state.isChangingCategory
                                    }
                                    style={{
                                      backgroundColor: getdatacommon.hexToRgba(
                                        this.state.selectStatus.color,
                                        0.1,
                                      ).backgroundColor,
                                      color:
                                        "#" +
                                        getdatacommon.hexToRgba(
                                          this.state.selectStatus.color,
                                          0.1,
                                        ).color,
                                      border: `1px solid ${
                                        getdatacommon.hexToRgba(
                                          this.state.selectStatus.color,
                                          0.1,
                                        ).borderColor
                                      }`,
                                    }}
                                  >
                                    <div className="filter-option">
                                      <div className="filter-option-inner">
                                        <div className="filter-option-inner-inner">
                                          {this.state.selectStatus.name}{" "}
                                          <i
                                            className="fa fa-chevron-down"
                                            style={{
                                              fontSize: "10px",
                                              lineHeight: "10px",
                                            }}
                                          ></i>
                                        </div>
                                      </div>{" "}
                                    </div>
                                  </button>
                                  {this.state.rows.sla_fields &&
                                    this.state.rows.sla_fields.includes(
                                      "status",
                                    ) &&
                                    this.getSlaMissedReasonByField(
                                      "status",
                                    ) && (
                                      <OverlayTrigger
                                        key={"status"}
                                        placement={"right"}
                                        overlay={
                                          <Tooltip
                                            id={`tooltip-status`}
                                            className="text-capitalize"
                                          >
                                            {this.getSlaMissedReasonByField(
                                              "status",
                                            )}
                                          </Tooltip>
                                        }
                                      >
                                        <i
                                          className="fa fa-info-circle ms-1 mt-1"
                                          style={{ cursor: "pointer" }}
                                        ></i>
                                      </OverlayTrigger>
                                    )}
                                </div>
                                {this.state.dropdown && (
                                  <div className="">
                                    <div
                                      className="inner show"
                                      role="listbox"
                                      id="bs-select-1"
                                      tabindex="-1"
                                    >
                                      {status?.length > 0 &&
                                        !this.state.isChangingCategory && (
                                          <Error>
                                            <StatusDropDown
                                              options={
                                                status?.[0]?.options || status
                                              }
                                              disabled={true}
                                              isChangingCategory={
                                                this.state.isChangingCategory
                                              }
                                              state={this.state.selectStatus}
                                              refs={this.dropref}
                                              hideDropdown={this.hideDropdown}
                                              selectStatusChange={
                                                this.selectStatusChange
                                              }
                                              currentStatusId={
                                                this.state.selectStatus
                                              }
                                            />
                                          </Error>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              {this.state.rows?.has_sla === true && (
                                <CountDownTimer
                                  missedCount={
                                    this.state.rows?.sla_missed_count
                                  }
                                  next_response_timestamp={
                                    this.state.rows?.next_response_timestamp
                                  }
                                  slaMissed={this.state.rows?.sla_missed}
                                  sla_response_time={
                                    this.state.rows?.sla_response_time
                                  }
                                />
                              )}
                            </div>
                          )}
                        </div>
                        <div className="middleright-block">
                          {details.length > 0 && (
                            <div className="middleLeft-block">
                              <div className="newdetails-block">
                                <div className="dblock-title">
                                  {attr}
                                  <div className="show_more_attribute">
                                    {!this.state.show_more_attribute &&
                                    this.state.hidden_panel.length > 0 ? (
                                      <Link
                                        className="show_more_attribute_detals"
                                        onClick={(evt) => {
                                          evt.preventDefault();
                                          this.showMoreAttributeHandler();
                                        }}
                                        to={"#"}
                                      >
                                        {"Show More Details >>"}
                                      </Link>
                                    ) : (
                                      hidden_pane
                                    )}
                                    {this.state.show_more_attribute &&
                                      this.state.hidden_panel.length > 0 && (
                                        <div className="mt-2">
                                          <Link
                                            className="show_more_attribute_detals"
                                            onClick={(evt) => {
                                              evt.preventDefault();
                                              this.showMoreAttributeHandler();
                                            }}
                                            to={"#"}
                                          >
                                            {"<< Hide Details"}
                                          </Link>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {people.length > 0 && (
                            <div className="rightProjectPlan-Block">
                              {peope}
                            </div>
                          )}
                          {release?.length > 0 && (
                            <div className="rightProjectPlan-Block">
                              {release}
                            </div>
                          )}

                          <div className="rightProjectPlan-Block">
                            <Row className="mt-2">
                              <div className="main_date_class">
                                {plannindDate}
                                {dev_project_plan.length > 0 &&
                                  dev_planning_date}
                                {qa_project_plan.length > 0 && qa_planning_date}
                                {scrum_project_plan.length > 0 &&
                                  scrum_planning_date}
                              </div>
                            </Row>
                          </div>
                        </div>
                        <div className="main_date_class p-2">
                          <div className="history_css_style mb-2 second_main_class">
                            {this.state?.recentVisited?.filter(
                              (itm) => itm != this.props.match.params.id,
                            ).length > 0 &&
                              this.state.boarddata.has_parent === 0 &&
                              this.getRecentVisited()}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              ) : (
                <Loading />
              )}
            </Container>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    uploadAtt: state.boardAttribute.allAttachImage,
    attributes: state.boardAttribute,
    logindata: state.loginDetails.loginData,
    note: state.note,
    user: state.note.users,
    allBoard: state.allBoards,
    boardDetails: state.statusworkflow.status_board_details,
    boardData: state.boardAttribute.filter,
    users: state.boardAttribute.users,
    toggleMenu: state.boardAttribute.toggleMenu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    callUserApi: (input) => {
      dispatch(action.userApiCall(input));
    },
    getBoardAttributes: (key) => {
      return dispatch(action.getTattleDetails(key));
    },
    removeMonitoring: (inputs, any) => {
      return dispatch(action.removeMonitor(inputs, any));
    },
    updateStatusRow: (id, newStatus, any) => {
      return dispatch(action.updateRowStatus(id, newStatus, any));
    },
    updateSingleRow: (inputs, any = null) => {
      return dispatch(action.updateSingleRow(inputs, any));
    },
    assignToUpdate: (inputs) => {
      dispatch(action.assignToUpdate(inputs));
    },
    setStatusChange: (inputs) => {
      dispatch(action.setNewStatus(inputs));
    },
    getAllUser: (inputs) => {
      dispatch(action.status.getAllWorkflowUser(inputs));
    },
    getBoardHistory: (inputs, any = null) => {
      return dispatch(action.getBoardHistory(inputs, any));
    },
    addNote: (inputs, list) => {
      return dispatch(action.addNoteBoard(inputs, list));
    },
    getNote: (inputs, any) => {
      return dispatch(action.getNoteBoard(inputs, any));
    },
    checkSidebarLink: (set_key) => {
      dispatch(action.checkLinkForSideMenu(set_key));
    },
    getBoardStatusDetails: (inputs) => {
      dispatch(action.getBoardStatusDetails(inputs));
    },
    stopPopup: (any = null) => {
      return dispatch(action?.stopPopup(any));
    },
    addMonitoring: (inputs, any) => {
      return dispatch(action.addMonitoring(inputs, any));
    },
    enableMonitoring: () => {
      dispatch(action.enableMonitoring());
    },
    uploadImage: (inputs) => {
      return dispatch(action.UploadImage(inputs));
    },
    updateAssignTo: (inputs, any) => {
      return dispatch(action.updateAssignTo(inputs, any));
    },
    clearImageEdit: (any = null) => {
      dispatch(clearAllAttachment(any));
    },
    updateAttachment: (inputs, any = null) => {
      dispatch(updateAttachmentData(inputs, any));
    },
    getBoardDetailsActions: (input) => {
      return dispatch(action.getBoardDetailsAction(input));
    },
    saveAttachment: (input, any = null) => {
      dispatch(action.dispatchAttachment(input, any));
    },
    addReasonRowUpdate: (input, any) => {
      return dispatch(action.addReasonRowUpdate(input, any));
    },
    removeTattleAttachment: (input) => {
      dispatch(action.removeAttachmnt(input));
    },
    clearBoardData: () => {
      dispatch(action?.clearBoardData());
    },
    relateViceVersa: (input, any) => {
      return dispatch(action.relateViceVersa(input, any));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(View));
